import React, { useState, useEffect } from 'react';
import compensacionService from '../services/compensacionService';
import configuracionTasaNocturnaService from '../services/configuracionTasaNocturnaService';

const TareoModal = ({ isOpen, onClose, empleado, configuracionesPlame, configuracionTareo, planillaFechaInicio, planillaFechaFin, autorizacionesPeriodo, generarBoletaIndividual, generandoBoletaIndividual, planillaId, planillaCerrada, empresaId = null }) => {
  const [tareoData, setTareoData] = useState(null);
  const [conceptosGenerados, setConceptosGenerados] = useState(null);
  const [tareosDiarios, setTareosDiarios] = useState([]);
  const [autorizacionesEmpleado, setAutorizacionesEmpleado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tasaNocturnaActiva, setTasaNocturnaActiva] = useState(false);

  // 🔍 EFECTO PARA MOSTRAR INFORMACIÓN DE CONFIGURACIÓN CUANDO CAMBIAN LAS PROPS
  useEffect(() => {
    if (isOpen && empleado) {
      console.log('🎯 === TAREO MODAL ABIERTO ===');
      console.log(`👤 Empleado: ${empleado.nombre_completo || empleado.nombre || 'N/A'}`);
      console.log(`🔒 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
      console.log('empleado1234', empleado);
      
      // 📊 DATOS COMPLETOS DEL EMPLEADO
      console.log('📊 DATOS COMPLETOS DEL EMPLEADO:', {
        id: empleado.id,
        nombre: empleado.nombre_completo || empleado.nombre,
        descuento_descanso: empleado.descuento_descanso,
        es_planilla_cerrada: empleado.es_planilla_cerrada
      });
      
      // ⚙️ CONFIGURACIÓN COMPLETA RECIBIDA
      console.log('⚙️ CONFIGURACIÓN COMPLETA RECIBIDA:', {
        descontar_descansos: configuracionTareo?.descontar_descansos,
        es_planilla_cerrada: configuracionTareo?.es_planilla_cerrada,
        tipo_tareo: configuracionTareo?.tipo_tareo,
        empresa_id: configuracionTareo?.empresa_id
      });
      
      if (planillaCerrada) {
        console.log(`💤 MODO PLANILLA CERRADA:`);
        console.log(`  • Descuento descanso del empleado: ${empleado.descuento_descanso ? 'ACTIVADO' : 'DESACTIVADO'}`);
        console.log(`  • Configuración sintética recibida: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
        console.log(`  • Es planilla cerrada (flag): ${configuracionTareo?.es_planilla_cerrada ? 'SÍ' : 'NO'}`);
        
        // 🚨 VERIFICACIÓN CRÍTICA
        if (!empleado.descuento_descanso) {
          console.warn('⚠️ EMPLEADO NO TIENE DESCUENTO_DESCANSO ACTIVADO - No se mostrarán descuentos');
        }
        if (!configuracionTareo?.descontar_descansos) {
          console.warn('⚠️ CONFIGURACIÓN SINTÉTICA NO TIENE DESCONTAR_DESCANSOS - Revisar lógica de PlanillaDetalle');
        }
      } else {
        console.log(`💤 MODO PLANILLA ABIERTA:`);
        console.log(`  • Configuración general: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
      }
    }
  }, [isOpen, empleado, planillaCerrada, configuracionTareo?.descontar_descansos]);
  const [mostrarEstadisticas, setMostrarEstadisticas] = useState(false);
  const [compensacionesEmpleado, setCompensacionesEmpleado] = useState(null);
  const [loadingCompensaciones, setLoadingCompensaciones] = useState(false);
  const columnasTablaTareos = tasaNocturnaActiva ? 7 : 6;

  useEffect(() => {
    if (!isOpen || !empresaId) {
      setTasaNocturnaActiva(false);
      return;
    }

    const cargarConfiguracionTasaNocturna = async () => {
      try {
        const response = await configuracionTasaNocturnaService.obtenerConfiguracion(empresaId);
        setTasaNocturnaActiva(Boolean(response?.success && response?.data?.activo));
      } catch (error) {
        console.error('Error al cargar configuración de tasa nocturna:', error);
        setTasaNocturnaActiva(false);
      }
    };

    cargarConfiguracionTasaNocturna();
  }, [isOpen, empresaId]);

  useEffect(() => {
    if (isOpen && empleado) {
      setLoading(true);
      console.log('🎯 TAREO MODAL - Datos del empleado:', empleado);
      
      // 📋 LOGEANDO ARRAY DEL EMPLEADO Y CÓDIGOS PLAME
      console.log('📊 === EMPLEADO COMPLETO RECIBIDO EN TAREO MODAL ===');
      console.log('👤 Empleado completo:', empleado);
      console.log('🆔 ID Empleado:', empleado?.id);
      console.log('📝 Nombre:', empleado?.nombre);
      console.log('📄 Documento:', empleado?.documento);
      console.log('💼 Cargo:', empleado?.cargo);
      
      // 💰 CONCEPTOS DEL EMPLEADO
      console.log('\n💰 === CONCEPTOS DEL EMPLEADO ===');
      console.log('📊 Conceptos completos:', empleado?.conceptos);
      console.log('📈 Ingresos:', empleado?.conceptos?.ingresos);
      console.log('📉 Descuentos:', empleado?.conceptos?.descuentos);
      console.log('🏛️ Aportes:', empleado?.conceptos?.aportes);
      
      // 🔍 CÓDIGOS PLAME ESPECÍFICOS
      console.log('\n🏛️ === CÓDIGOS PLAME EN CONCEPTOS ===');
      
      // Códigos PLAME en Ingresos
      if (empleado?.conceptos?.ingresos) {
        console.log('📈 CÓDIGOS PLAME - INGRESOS:');
        empleado.conceptos.ingresos.forEach((concepto, index) => {
          const codigoPlame = concepto.plame_configuracion?.codigo_plame || 
                             concepto.codigoPlame || 
                             concepto.codigo_plame || 
                             concepto.codigoPlame;
          console.log(`  ${index + 1}. ${concepto.descripcion || concepto.nombre}`);
          console.log(`     • Código PLAME: ${codigoPlame || 'Sin código'}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • PLAME Config:`, concepto.plame_configuracion);
        });
      }
      
      // Códigos PLAME en Descuentos
      if (empleado?.conceptos?.descuentos) {
        console.log('📉 CÓDIGOS PLAME - DESCUENTOS:');
        empleado.conceptos.descuentos.forEach((concepto, index) => {
          const codigoPlame = concepto.plame_configuracion?.codigo_plame || 
                             concepto.codigoPlame || 
                             concepto.codigo_plame || 
                             concepto.codigoPlame;
          console.log(`  ${index + 1}. ${concepto.descripcion || concepto.nombre}`);
          console.log(`     • Código PLAME: ${codigoPlame || 'Sin código'}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • PLAME Config:`, concepto.plame_configuracion);
        });
      }
      
      // Códigos PLAME en Aportes
      if (empleado?.conceptos?.aportes) {
        console.log('🏛️ CÓDIGOS PLAME - APORTES:');
        empleado.conceptos.aportes.forEach((concepto, index) => {
          const codigoPlame = concepto.plame_configuracion?.codigo_plame || 
                             concepto.codigoPlame || 
                             concepto.codigo_plame || 
                             concepto.codigoPlame;
          console.log(`  ${index + 1}. ${concepto.descripcion || concepto.nombre}`);
          console.log(`     • Código PLAME: ${codigoPlame || 'Sin código'}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • PLAME Config:`, concepto.plame_configuracion);
        });
      }
      
      // ⏰ TAREOS DEL EMPLEADO
      console.log('\n⏰ === TAREOS DEL EMPLEADO ===');
      console.log('📊 Tareos empleado:', empleado?.tareosEmpleado);
      console.log('📈 Resumen tareos:', empleado?.resumenTareos);
      
      if (empleado?.tareosEmpleado) {
        console.log(`📅 Total tareos: ${empleado.tareosEmpleado.length}`);
        empleado.tareosEmpleado.forEach((tareo, index) => {
          console.log(`  ${index + 1}. Fecha: ${tareo.fecha} | Tipo: ${tareo.tipo_evento || 'N/A'}`);
          if (tareo.conceptos && tareo.conceptos.length > 0) {
            console.log(`     💰 Conceptos en este tareo (${tareo.conceptos.length}):`);
            tareo.conceptos.forEach((concepto, cIndex) => {
              // ✅ BUSCAR CONCEPTO PLAME POR ID SI ES PLANILLA ABIERTA (solo tiene plame_configuracion_id)
              let codigoPlame = null;
              let descripcionConcepto = null;
              
              if (!planillaCerrada && concepto.plame_configuracion_id) {
                // Planilla abierta: buscar en configuracionesPlame usando el ID
                const conceptoPlameEncontrado = buscarConceptoPlamePorId(concepto.plame_configuracion_id);
                if (conceptoPlameEncontrado) {
                  codigoPlame = conceptoPlameEncontrado.codigo_plame;
                  descripcionConcepto = conceptoPlameEncontrado.descripcion;
                }
              }
              
              // Si no se encontró, usar los valores del objeto concepto directamente
              codigoPlame = codigoPlame || 
                           concepto.plame_configuracion?.codigo_plame || 
                           concepto.codigoPlame || 
                           concepto.codigo_plame;
              
              descripcionConcepto = descripcionConcepto || 
                                   concepto.plame_configuracion?.descripcion || 
                                   concepto.nombre || 
                                   concepto.descripcion || 
                                   'Sin nombre';
              
              console.log(`       ${cIndex + 1}. ${descripcionConcepto}`);
              console.log(`          • PLAME: ${codigoPlame || 'Sin código'}`);
              console.log(`          • Monto: ${concepto.monto || concepto.valor || 0}`);
              console.log(`          • PLAME Config ID: ${concepto.plame_configuracion_id || 'N/A'}`);
            });
          }
        });
      }
      
      // 🏛️ CONFIGURACIONES PLAME DISPONIBLES
      console.log('\n🏛️ === CONFIGURACIONES PLAME DISPONIBLES ===');
      console.log('🔒 Planilla cerrada:', planillaCerrada ? 'SÍ' : 'NO');
      console.log('📊 Configuraciones PLAME recibidas:', configuracionesPlame);
      console.log('📊 Total configuraciones PLAME:', configuracionesPlame?.length || 0);
      
      if (planillaCerrada && (!configuracionesPlame || configuracionesPlame.length === 0)) {
        console.warn('⚠️ PLANILLA CERRADA PERO SIN CONFIGURACIONES PLAME - Verificar carga en PlanillaDetalle');
      } else if (planillaCerrada && configuracionesPlame && configuracionesPlame.length > 0) {
        console.log('✅ PLANILLA CERRADA CON CONFIGURACIONES PLAME CORRECTAS');
      } else if (!planillaCerrada) {
        console.log('💡 PLANILLA ABIERTA - Configuraciones PLAME no necesarias');
      }
      
      if (configuracionesPlame && configuracionesPlame.length > 0) {
        console.log('🔍 Primeras 10 configuraciones PLAME:');
        configuracionesPlame.slice(0, 10).forEach((config, index) => {
          console.log(`  ${index + 1}. ID: ${config.id} | Código: ${config.codigo_plame} | Descripción: ${config.descripcion}`);
        });
      }

      // 🔍 LOGGING DETALLADO DE CONCEPTOS Y BASES DE CÁLCULO
      console.log('\n💰 === ANÁLISIS DE BASES DE CÁLCULO ===');
      console.log('🔍 Empleado completo:', empleado);
      console.log('🔍 Conceptos del empleado:', empleado?.conceptos);
      
      // Analizar ingresos
      console.log('\n📈 INGRESOS CON DETALLE:');
      if (empleado?.conceptos?.ingresos && empleado.conceptos.ingresos.length > 0) {
        empleado.conceptos.ingresos.forEach((concepto, index) => {
          console.log(`  ${index + 1}. ${concepto.descripcion}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • base_calculo: ${concepto.base_calculo}`);
          console.log(`     • baseCalculo: ${concepto.baseCalculo}`);
          console.log(`     • valor: ${concepto.valor}`);
          console.log(`     • Todas las propiedades:`, Object.keys(concepto));
          console.log(`     • Concepto completo:`, concepto);
          console.log('');
        });
      } else {
        console.log('  ⚠️ No se encontraron ingresos en empleado.conceptos.ingresos');
      }
      
      // Analizar descuentos
      console.log('\n📉 DESCUENTOS CON DETALLE:');
      if (empleado?.conceptos?.descuentos && empleado.conceptos.descuentos.length > 0) {
        empleado.conceptos.descuentos.forEach((concepto, index) => {
          console.log(`  ${index + 1}. ${concepto.descripcion}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • base_calculo: ${concepto.base_calculo}`);
          console.log(`     • baseCalculo: ${concepto.baseCalculo}`);
          console.log(`     • valor: ${concepto.valor}`);
          console.log(`     • Todas las propiedades:`, Object.keys(concepto));
          console.log(`     • Concepto completo:`, concepto);
          console.log('');
        });
      } else {
        console.log('  ⚠️ No se encontraron descuentos en empleado.conceptos.descuentos');
      }
      
      // Analizar aportes
      console.log('\n🏛️ APORTES CON DETALLE:');
      if (empleado?.conceptos?.aportes && empleado.conceptos.aportes.length > 0) {
        empleado.conceptos.aportes.forEach((concepto, index) => {
          console.log(`  ${index + 1}. ${concepto.descripcion}`);
          console.log(`     • Monto: ${concepto.monto}`);
          console.log(`     • base_calculo: ${concepto.base_calculo}`);
          console.log(`     • baseCalculo: ${concepto.baseCalculo}`);
          console.log(`     • valor: ${concepto.valor}`);
          console.log(`     • Todas las propiedades:`, Object.keys(concepto));
          console.log(`     • Concepto completo:`, concepto);
          console.log('');
        });
      } else {
        console.log('  ⚠️ No se encontraron aportes en empleado.conceptos.aportes');
      }
      
      // 🔐 AUTORIZACIONES DEL PERÍODO PARA ESTE EMPLEADO
      console.log('\n🔐 === AUTORIZACIONES DEL PERÍODO ===');
      console.log('📊 Autorizaciones recibidas:', autorizacionesPeriodo);
      console.log('📊 Total autorizaciones periodo:', autorizacionesPeriodo?.length || 0);
      console.log('🆔 Empleado ID para filtrar:', empleado?.id);
      
      // Filtrar autorizaciones por empleado
      const autorizacionesDelEmpleado = autorizacionesPeriodo?.filter(autorizacion => 
        autorizacion.empleado_id === empleado?.id
      ) || [];
      
      console.log('🎯 Autorizaciones del empleado filtradas:', autorizacionesDelEmpleado);
      console.log('📊 Total autorizaciones del empleado:', autorizacionesDelEmpleado.length);
      
      if (autorizacionesDelEmpleado.length > 0) {
        console.log('🔍 Detalle de autorizaciones del empleado:');
        autorizacionesDelEmpleado.forEach((autorizacion, index) => {
          console.log(`  ${index + 1}. Tipo: ${autorizacion.tipo_autorizacion}`);
          console.log(`     • Sub-tipo: ${autorizacion.sub_tipo || 'N/A'}`);
          console.log(`     • Fecha inicio: ${autorizacion.fecha_inicio}`);
          console.log(`     • Fecha fin: ${autorizacion.fecha_fin || 'Sin fin'}`);
          console.log(`     • Días: ${autorizacion.dias || 0}`);
          console.log(`     • Horas: ${autorizacion.horas || 0}`);
          console.log(`     • Estado: ${autorizacion.estado}`);
          console.log(`     • Motivo: ${autorizacion.motivo || 'Sin motivo'}`);
        });
      }
      
      console.log('🏁 === FIN DE LOGS TAREO MODAL ===\n');
      
      // Usar datos reales del array en lugar de simulados
      setTimeout(() => {
        setTareoData(empleado.tareos || empleado.resumenTareos);
        
        // Usar tareos reales del empleado
        const tareosReales = empleado.tareosEmpleado || [];
        console.log('📅 TAREOS REALES DEL EMPLEADO:', tareosReales);
        console.log('📊 TOTAL TAREOS DEL EMPLEADO:', tareosReales.length);
        console.log('🔍 ESTRUCTURA DEL EMPLEADO COMPLETA:', empleado);
        
        // 🔍 ANÁLISIS DETALLADO DE LOS TAREOS
        if (tareosReales.length > 0) {
          console.log('🎯 === ANÁLISIS DE TAREOS INDIVIDUALES ===');
          tareosReales.forEach((tareo, index) => {
            console.log(`📅 Tareo ${index + 1}:`);
            console.log('array de tareos', tareosReales);
            console.log(`  • Fecha: "${tareo.fecha}"`);
            console.log(`  • Tipo evento: "${tareo.tipo_evento}"`);
            console.log(`  • Estado: "${tareo.estado}"`);
            console.log(`  • Horas trabajadas: "${tareo.horas_trabajadas}"`);
            console.log(`  • Conceptos:`, tareo.conceptos?.length || 0);
            console.log('  • Tareo completo:', tareo);
            console.log('');
          });
        } else {
          console.log('⚠️ NO SE ENCONTRARON TAREOS EN empleado.tareosEmpleado');
          console.log('🔍 Revisando otras propiedades posibles:');
          console.log('  • empleado.tareos:', empleado.tareos);
          console.log('  • empleado.resumenTareos:', empleado.resumenTareos);
          console.log('  • Todas las claves del empleado:', Object.keys(empleado));
        }
        
        if (tareosReales.length === 0) {
          console.log('⚠️ NO SE ENCONTRARON TAREOS PARA EL EMPLEADO');
          console.log('🔍 Verificando otras propiedades del empleado:', {
            tareosEmpleado: empleado.tareosEmpleado,
            resumenTareos: empleado.resumenTareos,
            todasLasPropiedades: Object.keys(empleado)
          });
        }
        
        // Formatear tareos para la vista
        const tareosFormateados = formatearTareosParaVista(tareosReales);
        console.log('✅ TAREOS FORMATEADOS PARA VISTA:', tareosFormateados);
        setTareosDiarios(tareosFormateados);
        
        // Los conceptos ya vienen en el empleado
        setConceptosGenerados(null); // No necesitamos generar conceptos
        
        // Establecer autorizaciones del empleado
        setAutorizacionesEmpleado(autorizacionesDelEmpleado);
        console.log('✅ AUTORIZACIONES DEL EMPLEADO ESTABLECIDAS EN EL ESTADO:', autorizacionesDelEmpleado);
        
                  // 💤 CARGAR COMPENSACIONES DEL EMPLEADO
          if (planillaId && empleado?.id) {
            cargarCompensacionesEmpleado();
          } else {
            console.log('⚠️ No se cargarán compensaciones: planillaId=' + planillaId + ', empleadoId=' + empleado?.id);
            setCompensacionesEmpleado(null);
          }
        
        setLoading(false);
      }, 300);
    }
  }, [isOpen, empleado]);

  // 🏛️ FUNCIÓN HELPER PARA BUSCAR CONCEPTO PLAME POR ID
  const buscarConceptoPlamePorId = (plameConfiguracionId) => {
    if (!plameConfiguracionId || !configuracionesPlame || configuracionesPlame.length === 0) {
      return null;
    }
    
    const conceptoEncontrado = configuracionesPlame.find(config => config.id === plameConfiguracionId);
    console.log(`🔍 Buscando concepto PLAME ID: ${plameConfiguracionId}`);
    console.log(`✅ Concepto encontrado:`, conceptoEncontrado);
    
    return conceptoEncontrado;
  };

  // 💤 FUNCIÓN PARA CARGAR COMPENSACIONES DEL EMPLEADO
  const cargarCompensacionesEmpleado = async () => {
    if (!planillaId) {
      console.log('⚠️ No se puede cargar compensaciones: planillaId no disponible');
      return;
    }

    setLoadingCompensaciones(true);
    
    try {
      console.log(`💤 Cargando compensaciones para planilla ${planillaId}...`);
      
      const resultado = await compensacionService.obtenerCompensacionesPorPlanilla(planillaId);
      
      if (resultado.success) {
        // Filtrar solo la compensación de este empleado (comparación numérica para evitar string vs number)
        const idEmp = empleado?.id != null ? Number(empleado.id) : null;
        const compensacionDelEmpleado = resultado.data.find(comp => idEmp != null && Number(comp.empleado_id) === idEmp);
        
        if (compensacionDelEmpleado) {
          console.log(`✅ Compensación del empleado encontrada:`, compensacionDelEmpleado);
          setCompensacionesEmpleado({
            compensacion: compensacionDelEmpleado
          });
        } else {
          console.log(`⚠️ No se encontró compensación para el empleado ${empleado?.id}`);
          setCompensacionesEmpleado({
            compensacion: null
          });
        }
      } else {
        console.error(`❌ Error al cargar compensaciones: ${resultado.error}`);
        setCompensacionesEmpleado(null);
      }
    } catch (error) {
      console.error(`❌ Error inesperado al cargar compensaciones:`, error);
      setCompensacionesEmpleado(null);
    } finally {
      setLoadingCompensaciones(false);
    }
  };

  // 📅 FUNCIÓN PARA FORMATEAR TAREOS REALES DEL BACKEND
  const formatearTareosParaVista = (tareosReales) => {
    console.log('🔧 FORMATEANDO TAREOS REALES:', tareosReales);
    
    const result = tareosReales.map((tareo, index) => {
      console.log(`📅 Procesando tareo ${index + 1}:`);
      console.log(`  • Fecha original de API: "${tareo.fecha}"`);
      console.log(`  • Tipo de fecha:`, typeof tareo.fecha);
      
      // 🔧 CREAR FECHA CORRECTAMENTE SIN PROBLEMAS DE TIMEZONE
      // Extraer solo la parte de fecha sin tiempo ni timezone
      const fechaString = tareo.fecha.split('T')[0]; // "2025-06-26"
      console.log(`  • Fecha string extraída: "${fechaString}"`);
      
      // Crear fecha local sin conversiones de timezone
      const [year, month, day] = fechaString.split('-').map(Number);
      const fecha = new Date(year, month - 1, day); // month - 1 porque Date usa 0-indexado
      
      console.log(`  • Fecha parseada (local): ${fecha}`);
      console.log(`  • ¿Fecha válida?: ${!isNaN(fecha.getTime())}`);
      console.log(`  • Año: ${fecha.getFullYear()}, Mes: ${fecha.getMonth() + 1}, Día: ${fecha.getDate()}`);
      
      // Formatear fecha para la vista
      const fechaFormateada = fecha.toLocaleDateString('es-PE', { 
        weekday: 'short', 
        day: '2-digit', 
        month: '2-digit' 
      });
      
      const diaSemana = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][fecha.getDay()];
      
      console.log(`  • Fecha formateada: "${fechaFormateada}"`);
      console.log(`  • Día semana: "${diaSemana}"`);
      console.log(`  • Año: ${fecha.getFullYear()}, Mes: ${fecha.getMonth() + 1}, Día: ${fecha.getDate()}`);
      console.log('');  // Línea en blanco para separar
      
      // Determinar tipo de tareo basado en los campos reales del backend
      let tipo = 'Asistió';
      let estadoVista = 'completo';
      
      // Usar tipo_evento para determinar el tipo
      if (tareo.tipo_evento === 'falta') {
        tipo = 'Falta';
        estadoVista = 'falta';
      } else if (tareo.tipo_evento === 'feriado') {
        tipo = 'Feriado';
        estadoVista = 'feriado';
      } else if (tareo.tipo_evento === 'feriado_laborado') {
        tipo = 'Feriado Laborado';
        estadoVista = 'feriado_laborado';
      } else if (tareo.tipo_evento === 'descanso') {
        tipo = 'Descanso';
        estadoVista = 'descanso';
      } else if (tareo.tipo_evento === 'descanso_laborado') {
        tipo = 'Descanso Laborado';
        estadoVista = 'descanso_laborado';
      } else if (tareo.tipo_evento === 'descanso_medico') {
        tipo = 'Descanso Médico';
        estadoVista = 'descanso_medico';
      } else if (tareo.tipo_evento === 'reposo_medico') {
        tipo = 'Reposo Médico';
        estadoVista = 'reposo_medico';
      } else if (tareo.tipo_evento === 'subsidio_por_enfermedad') {
        tipo = 'Subsidio por Enfermedad';
        estadoVista = 'subsidio_por_enfermedad';
      } else if (tareo.tipo_evento === 'licencia_con_goce_de_haber') {
        tipo = 'Licencia con Goce de Haber';
        estadoVista = 'licencia_con_goce_de_haber';
      } else if (tareo.tipo_evento === 'permiso') {
        tipo = 'Permiso';
        estadoVista = 'permiso';
      } else if (tareo.tipo_evento === 'suspension') {
        tipo = 'Suspensión';
        estadoVista = 'suspension';
      } else if (tareo.tipo_evento === 'vacaciones') {
        tipo = 'Vacaciones';
        estadoVista = 'vacaciones';
      } else if (tareo.estado === 'tardanza') {
        tipo = 'Asistió';
        estadoVista = 'tardanza';
      } else if (parseFloat(tareo.horas_trabajadas) < 8 && parseFloat(tareo.horas_trabajadas) > 0) {
        estadoVista = 'incompleto';
      }
      
      console.log(`  • Tipo evento API: "${tareo.tipo_evento}" → Tipo vista: "${tipo}" → Estado: "${estadoVista}"`);
      
      // Formatear horas según el tipo de evento
      let horasOrdinarias = parseFloat(tareo.horas_trabajadas) || 0;
      
      // 🔧 AJUSTAR HORAS SEGÚN TIPO DE EVENTO
      if (tareo.tipo_evento === 'falta') {
        horasOrdinarias = 0; // Las faltas siempre tienen 0 horas
        console.log(`  • ⚠️ FALTA detectada: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'vacaciones') {
        horasOrdinarias = 0; // Las vacaciones no cuentan como horas trabajadas
        console.log(`  • 🏖️ VACACIONES detectadas: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'permiso' || tareo.tipo_evento === 'suspension') {
        horasOrdinarias = 0;
        console.log(`  • 📝 PERMISO/SUSPENSIÓN detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'feriado') {
        horasOrdinarias = 8; // Feriados normales tienen 8 horas
        console.log(`  • 🎉 FERIADO detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'descanso' && horasOrdinarias > 0) {
        horasOrdinarias = 0; // Descansos normales (no laborados) tienen 0 horas
        console.log(`  • 😴 DESCANSO detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'descanso_medico') {
        horasOrdinarias = 8; // Descanso médico = 8 horas
        console.log(`  • 🏥 DESCANSO MÉDICO detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'reposo_medico') {
        horasOrdinarias = 0; // Reposo médico = 0 horas
        console.log(`  • 🛏️ REPOSO MÉDICO detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'subsidio_por_enfermedad') {
        horasOrdinarias = 8; // Subsidio por enfermedad = 8 horas
        console.log(`  • 💊 SUBSIDIO POR ENFERMEDAD detectado: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      } else if (tareo.tipo_evento === 'licencia_con_goce_de_haber') {
        horasOrdinarias = 8; // Licencia con goce = 8 horas (igual que subsidio)
        console.log(`  • 🧾 LICENCIA CON GOCE DE HABER detectada: horas ajustadas de ${tareo.horas_trabajadas} a ${horasOrdinarias}`);
      }
      
      console.log(`  • Horas finales: ${horasOrdinarias}h decimales`);
      
      const horaEntrada = tareo.hora_entrada_real || tareo.hora_entrada_teorica || '08:00:00';
      const horaSalida = tareo.hora_salida_real || tareo.hora_salida_teorica || '17:00:00';
      
      // 🕐 EXTRAER HORARIOS TEÓRICOS SEPARADOS PARA LA VISTA
      const horaEntradaTeorica = tareo.hora_entrada_teorica || '08:00:00';
      const horaSalidaTeorica = tareo.hora_salida_teorica || '17:00:00';
      
      console.log(`  • Horarios teóricos: Entrada ${horaEntradaTeorica} - Salida ${horaSalidaTeorica}`);
      console.log(`  • Horarios reales: Entrada ${tareo.hora_entrada_real || 'N/A'} - Salida ${tareo.hora_salida_real || 'N/A'}`);
      
      // 🕐 CALCULAR HORAS TEÓRICAS PARA ESTE REGISTRO
      const horasTeoricasDecimales = calcularHorasTeoricasDecimales(horaEntradaTeorica, horaSalidaTeorica);
      console.log(`  • Horas teóricas calculadas: ${horasTeoricasDecimales}h decimales`);
      
      return {
        fecha: tareo.fecha,
        fechaFormateada,
        diaSemana,
        tipo,
        horaEntrada: horaEntrada.substring(0, 5), // Solo HH:MM
        horaSalida: horaSalida.substring(0, 5), // Solo HH:MM
        horaEntradaTeorica: horaEntradaTeorica.substring(0, 8), // HH:MM:SS
        horaSalidaTeorica: horaSalidaTeorica.substring(0, 8), // HH:MM:SS
        horasTeoricasDecimales, // Agregar las horas teóricas calculadas
        horasOrdinarias,
        horasExtra25: 0, // Por ahora, agregar lógica si hay campos específicos
        horasExtra35: 0, // Por ahora, agregar lógica si hay campos específicos
        observaciones: tareo.observaciones || '',
        estado: estadoVista,
        proyecto: tareo.proyecto_id ? `Proyecto ${tareo.proyecto_id}` : 'Sin proyecto',
        conceptos: tareo.conceptos || [],
        estadoOriginal: tareo.estado,
        tipoEvento: tareo.tipo_evento,
        considerarTasaNocturna: Boolean(tareo.considerar_tasa_nocturna),
      };
    });
    
    // 🔢 VERIFICAR CÁLCULO DE HORAS TOTALES
    const horasTotalesCalculadas = result.reduce((sum, t) => sum + t.horasOrdinarias, 0);
    console.log(`📊 === VERIFICACIÓN DE HORAS TOTALES ===`);
    console.log(`📈 Horas individuales por día:`, result.map(t => `${t.fechaFormateada}: ${t.horasOrdinarias}h decimales (${t.tipo})`));
    console.log(`🎯 Horas totales calculadas: ${horasTotalesCalculadas}h decimales`);
    console.log(`🏛️ Horas del backend (resumen): ${empleado?.resumenTareos?.horas_totales || 'N/A'}h decimales`);
    console.log(`✅ Usando horas calculadas: ${horasTotalesCalculadas}h decimales`);
    
    return result;
  };



  // 📅 FUNCIÓN PARA DETERMINAR SI UNA FECHA ESTÁ DENTRO DEL PERÍODO DE LA PLANILLA
  const esFechaFueraDePeriodo = (fechaTareo) => {
    if (!planillaFechaInicio || !planillaFechaFin || !fechaTareo) {
      return false; // Si no hay fechas definidas, no marcar como fuera del período
    }
    
    try {
      // Convertir fechas a formato comparable (YYYY-MM-DD)
      const fechaTareoStr = fechaTareo.split('T')[0]; // Solo la parte de fecha
      const fechaInicioStr = planillaFechaInicio.split('T')[0]; 
      const fechaFinStr = planillaFechaFin.split('T')[0];
      
      // Verificar si está fuera del rango
      const estaFuera = fechaTareoStr < fechaInicioStr || fechaTareoStr > fechaFinStr;
      
      if (estaFuera) {
        console.log(`🔍 Fecha ${fechaTareoStr} está FUERA del período ${fechaInicioStr} - ${fechaFinStr}`);
      }
      
      return estaFuera;
    } catch (error) {
      console.error('Error comparando fechas:', error);
      return false;
    }
  };

  if (!isOpen) return null;

  const getStatusColor = (value, total) => {
    if (value === 0) return 'text-green-600';
    if (value < total * 0.1) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getAsistenciaColor = (perfecto) => {
    return perfecto ? 'text-green-600' : 'text-yellow-600';
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(amount);
  };

  // 🕐 FUNCIÓN PARA CONVERTIR HORAS DECIMALES A HORAS Y MINUTOS
  // Convierte formato decimal (base 100) a formato real (base 60)
  // Ejemplos: 7.73h → 7h 44min | 7.48h → 7h 29min | 8.00h → 8h 0min
  const formatHorasMinutos = (horasDecimales) => {
    if (!horasDecimales || horasDecimales === 0) {
      return '0h 0min';
    }
    
    const horas = Math.floor(horasDecimales);
    const minutos = Math.round((horasDecimales - horas) * 60);
    
    return `${horas}h ${minutos}min`;
  };

  // 🕐 FUNCIÓN PARA CALCULAR HORAS TEÓRICAS BASADAS EN HORARIOS DE ENTRADA Y SALIDA
  // Aplica la misma lógica del backend: descuenta 1 hora de almuerzo si se trabaja más de 6 horas
  const calcularHorasTeoricasDecimales = (horaEntradaTeorica, horaSalidaTeorica) => {
    if (!horaEntradaTeorica || !horaSalidaTeorica) {
      return 8; // Fallback a 8 horas si no hay datos
    }

    try {
      // Parsear horas de entrada y salida (formato HH:MM:SS)
      const [horaEntrada, minutoEntrada] = horaEntradaTeorica.split(':').map(Number);
      const [horaSalida, minutoSalida] = horaSalidaTeorica.split(':').map(Number);
      
      // Convertir a minutos desde medianoche
      const minutosEntrada = horaEntrada * 60 + minutoEntrada;
      const minutosSalida = horaSalida * 60 + minutoSalida;
      
      // Calcular diferencia en minutos
      let diferenciaMinutos = minutosSalida - minutosEntrada;
      
      // Si la salida es menor que la entrada, es del día siguiente
      if (diferenciaMinutos < 0) {
        diferenciaMinutos += 24 * 60; // Agregar 24 horas
      }
      
      // Convertir a horas decimales brutas
      let horasDecimales = diferenciaMinutos / 60;
      
      // 🍽️ APLICAR LA MISMA LÓGICA DEL BACKEND: 
      // Descanso automático de 1 hora si trabajó más de 6 horas
      if (horasDecimales > 6) {
        horasDecimales -= 1;
        console.log(`🍽️ Descuento de 1h de almuerzo aplicado. Horas brutas: ${diferenciaMinutos / 60}h → Horas netas: ${horasDecimales}h`);
      }
      
      console.log(`🕐 Calculando horas teóricas: ${horaEntradaTeorica} a ${horaSalidaTeorica} = ${horasDecimales}h decimales (incluyendo descuento de almuerzo si aplica)`);
      
      return Math.max(0, horasDecimales); // Asegurar que no sea negativo
    } catch (error) {
      console.error('Error calculando horas teóricas:', error);
      return 8; // Fallback en caso de error
    }
  };

  const getEstadoColor = (estado) => {
    const colores = {
      'completo': 'text-green-600 bg-green-50',
      'tardanza': 'text-yellow-600 bg-yellow-50',
      'falta': 'text-red-600 bg-red-50',
      'feriado': 'text-purple-600 bg-purple-50',
      'feriado_laborado': 'text-orange-600 bg-orange-50',
      'descanso': 'text-blue-600 bg-blue-50',
      'descanso_laborado': 'text-indigo-600 bg-indigo-50',
      'descanso_medico': 'text-pink-600 bg-pink-50',
      'reposo_medico': 'text-rose-600 bg-rose-50',
      'subsidio_por_enfermedad': 'text-red-500 bg-red-50',
      'licencia_con_goce_de_haber': 'text-indigo-600 bg-indigo-50',
      'permiso': 'text-cyan-600 bg-cyan-50',
      'suspension': 'text-amber-600 bg-amber-50',
      'vacaciones': 'text-yellow-600 bg-yellow-50',
      'incompleto': 'text-amber-600 bg-amber-50'
    };
    return colores[estado] || 'text-gray-600 bg-gray-50';
  };

  const getTipoIcon = (tipo) => {
    const iconos = {
      'Asistió': '✅',
      'Falta': '❌',
      'Feriado': '🎉',
      'Feriado Laborado': '💼',
      'Descanso': '😴',
      'Descanso Laborado': '⚡',
      'Descanso Médico': '🏥',
      'Reposo Médico': '🛏️',
      'Subsidio por Enfermedad': '💊',
      'Licencia con Goce de Haber': '🧾',
      'Permiso': '📋',
      'Suspensión': '⛔',
      'Vacaciones': '🏖️'
    };
    return iconos[tipo] || '📅';
  };

  // 🔐 FUNCIÓN PARA PROCESAR HORAS EXTRAS DE AUTORIZACIONES
  const procesarHorasExtrasAutorizaciones = () => {
    if (!autorizacionesEmpleado || autorizacionesEmpleado.length === 0) {
      return { horasExtra25: 0, horasExtra35: 0 };
    }

    console.log('🔐 === PROCESANDO HORAS EXTRAS DE AUTORIZACIONES ===');
    console.log('📊 Autorizaciones a procesar:', autorizacionesEmpleado);

    let horasExtra25 = 0;
    let horasExtra35 = 0;

    autorizacionesEmpleado.forEach((autorizacion, index) => {
      console.log(`🔐 Procesando autorización ${index + 1}:`, autorizacion);
      
      // Solo procesar autorizaciones de horas-extra que estén aprobadas
      if (autorizacion.tipo_autorizacion === 'horas-extra' && autorizacion.estado === 'aprobado') {
        const horas = parseFloat(autorizacion.horas || 0);
        console.log(`  • Horas autorizadas: ${horas}`);
        console.log(`  • Sub-tipo: ${autorizacion.sub_tipo || 'N/A'}`);
        
        // Clasificar según sub-tipo o asignar por defecto
        if (autorizacion.sub_tipo === '25%' || autorizacion.sub_tipo === '25') {
          horasExtra25 += horas;
          console.log(`  ✅ Sumado a horas extra 25%: ${horas}h`);
        } else if (autorizacion.sub_tipo === '35%' || autorizacion.sub_tipo === '35') {
          horasExtra35 += horas;
          console.log(`  ✅ Sumado a horas extra 35%: ${horas}h`);
        } else {
          // Por defecto, asignar a 25% si no se especifica
          horasExtra25 += horas;
          console.log(`  ✅ Sin sub-tipo específico, sumado a horas extra 25%: ${horas}h`);
        }
      } else {
        console.log(`  ⚠️ Autorización omitida - Tipo: ${autorizacion.tipo_autorizacion}, Estado: ${autorizacion.estado}`);
      }
    });

    console.log(`🔐 RESULTADO FINAL AUTORIZACIONES:`);
    console.log(`  • Horas Extra 25%: ${horasExtra25}h`);
    console.log(`  • Horas Extra 35%: ${horasExtra35}h`);
    console.log('🔐 === FIN PROCESAMIENTO AUTORIZACIONES ===');

    return { horasExtra25, horasExtra35 };
  };

  // Función para verificar si hay suficientes tareos para mostrar estadísticas
  const tieneTareosParaEstadisticas = () => {
    // 📅 USAR SOLO TAREOS DEL PERÍODO (NO EN PLOMO) PARA VERIFICAR ESTADÍSTICAS
    const tareosFiltradosEstadisticas = tareosDiarios.filter(registro => 
      !esFechaFueraDePeriodo(registro.fecha)
    );
    const totalTareos = tareosFiltradosEstadisticas.length;
    // Mostrar estadísticas si hay al menos 2 tareos registrados
    const minimoTareos = 2;
    
    console.log('🔍 Verificando si hay tareos suficientes para estadísticas:');
    console.log(`  • Total tareos del período: ${totalTareos}`);
    console.log(`  • Total tareos extendidos: ${tareosDiarios.length}`);
    console.log(`  • Mínimo requerido: ${minimoTareos}`);
    console.log(`  • ¿Mostrar estadísticas?: ${totalTareos >= minimoTareos}`);
    
    return totalTareos >= minimoTareos;
  };

  // 📅 FUNCIÓN PARA CALCULAR RESÚMENES SEMANALES (INCLUYE DÍAS EN PLOMO)
  const calcularResumenSemanal = () => {
    console.log('📊 === CALCULANDO RESÚMENES SEMANALES ===');
    console.log(`🔒 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
    console.log(`👤 Empleado: ${empleado?.nombre_completo || empleado?.nombre || 'N/A'}`);
    
    if (planillaCerrada) {
      console.log(`💤 PLANILLA CERRADA - Descuento descansos del empleado: ${empleado?.descuento_descanso ? 'ACTIVADO' : 'DESACTIVADO'}`);
      console.log(`⚙️ Configuración recibida (sintética): ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
      console.log(`🎯 Es planilla cerrada: ${configuracionTareo?.es_planilla_cerrada ? 'SÍ' : 'NO'}`);
    } else {
      console.log(`💤 PLANILLA ABIERTA - Configuración general: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
    }
    
    console.log(`💤 Valor final usado: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
    
    // Agrupar tareos por semanas (de lunes a domingo)
    const semanas = [];
    let semanaActual = [];
    
    tareosDiarios.forEach((registro, index) => {
      // Agregar tareo a la semana actual
      semanaActual.push(registro);
      
      // Si es domingo O es el último tareo, cerrar la semana
      const esDomingo = registro.diaSemana === 'Dom';
      const esUltimoTareo = index === tareosDiarios.length - 1;
      
      if (esDomingo || esUltimoTareo) {
        if (semanaActual.length > 0) {
          // Calcular totales de la semana (INCLUYE días en plomo)
          const horasTotalesSemana = semanaActual.reduce((sum, t) => sum + t.horasOrdinarias, 0);
          const diasTrabajadosSemana = semanaActual.filter(t => 
            t.tipo === 'Asistió' || 
            t.tipo === 'Feriado Laborado' || 
            t.tipo === 'Descanso Laborado' ||
            t.tipo === 'Descanso Médico' ||
            t.tipo === 'Subsidio por Enfermedad' ||
            t.tipo === 'Licencia con Goce de Haber'
          ).length;
          
          // Separar días del período vs días en plomo
          const tareosPeriodo = semanaActual.filter(t => !esFechaFueraDePeriodo(t.fecha));
          const tareosEnPlomo = semanaActual.filter(t => esFechaFueraDePeriodo(t.fecha));
          
          const horasPeriodo = tareosPeriodo.reduce((sum, t) => sum + t.horasOrdinarias, 0);
          const horasEnPlomo = tareosEnPlomo.reduce((sum, t) => sum + t.horasOrdinarias, 0);
          
          // 📅 DEFINIR FECHAS DE LA SEMANA PRIMERO
          const fechaInicio = semanaActual[0].fechaFormateada;
          const fechaFin = semanaActual[semanaActual.length - 1].fechaFormateada;
          
          // 📊 CALCULAR DESCANSO PROPORCIONAL SI ESTÁ ACTIVADO
          let descansoProporcionado = 0;
          let infoDescanso = null;
          
          // 🔍 LOG DETALLADO DE CONFIGURACIÓN
          console.log(`🔍 === VERIFICANDO DESCUENTO DE DESCANSOS PARA SEMANA ${fechaInicio} - ${fechaFin} ===`);
          console.log(`🔒 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
          if (planillaCerrada) {
            console.log(`💤 Descuento individual del empleado: ${empleado?.descuento_descanso ? 'ACTIVADO' : 'DESACTIVADO'}`);
          }
          console.log(`⚙️ Configuración efectiva: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
          
          if (configuracionTareo?.descontar_descansos) {
            console.log(`✅ DESCUENTO DE DESCANSOS ACTIVADO - Procesando semana...`);
            
            // Contar faltas en la semana (solo del período de planilla)
            const faltasSemana = tareosPeriodo.filter(t => t.tipo === 'Falta').length;
            
            // Determinar días laborables del período (INCLUIR TODA LA SEMANA)
            // Todos los días se consideran laborables porque solo se identifican eventos "falta"
            const diasLaborablesSemana = tareosPeriodo.length;
            
            // Días trabajados efectivos (sin faltas)
            const diasTrabajadosEfectivos = Math.max(0, diasLaborablesSemana - faltasSemana);
            
            // ✅ NUEVA LÓGICA: Descanso base 8h - descuento por faltas (8/7 × faltas)
            const descansoBase = 8;
            const descuentoPorFalta = (8 / 7) * faltasSemana;
            descansoProporcionado = Math.max(0, descansoBase - descuentoPorFalta);
            
            infoDescanso = {
              diasLaborables: diasLaborablesSemana,
              faltas: faltasSemana,
              diasTrabajadosEfectivos,
              descansoCompleto: 8,
              descansoProporcionado
            };
            
            console.log(`💤 DESCANSO CON NUEVA LÓGICA - Semana ${fechaInicio} - ${fechaFin}:`);
            console.log(`  • Días laborables: ${diasLaborablesSemana} (incluye toda la semana)`);
            console.log(`  • Faltas: ${faltasSemana}`);
            console.log(`  • Días trabajados efectivos: ${diasTrabajadosEfectivos}`);
            console.log(`  • Descuento por faltas: ${descuentoPorFalta.toFixed(2)}h (8/7 × ${faltasSemana})`);
            console.log(`  • Descanso final: ${descansoProporcionado.toFixed(2)}h de 8h base`);
          }
          
          console.log(`📅 Semana ${fechaInicio} - ${fechaFin}:`);
          console.log(`  • Total horas: ${horasTotalesSemana}h (${horasPeriodo}h período + ${horasEnPlomo}h plomo)`);
          console.log(`  • Días trabajados: ${diasTrabajadosSemana}`);
          console.log(`  • Tareos: ${semanaActual.length}`);
          if (infoDescanso) {
            console.log(`  • Descanso: ${infoDescanso.descansoProporcionado.toFixed(2)}h de 8h base (${infoDescanso.faltas} faltas, descuento: ${((8/7) * infoDescanso.faltas).toFixed(2)}h)`);
          }
          
          semanas.push({
            tareos: [...semanaActual],
            fechaInicio,
            fechaFin,
            horasTotal: horasTotalesSemana,
            horasPeriodo,
            horasEnPlomo,
            diasTrabajados: diasTrabajadosSemana,
            totalTareos: semanaActual.length,
            esDomingo,
            infoDescanso
          });
        }
        
        // Reiniciar para la siguiente semana
        semanaActual = [];
      }
    });
    
    console.log(`📊 Total semanas calculadas: ${semanas.length}`);
    
    // 📊 RESUMEN FINAL DE SEMANAS CON INFORMACIÓN DE DESCUENTO
    console.log('🗓️ === RESUMEN DE SEMANAS CALCULADAS ===');
    semanas.forEach((semana, index) => {
      console.log(`📅 Semana ${index + 1} (${semana.fechaInicio} - ${semana.fechaFin}):`);
      console.log(`  • Horas total: ${semana.horasTotal}h`);
      console.log(`  • Días trabajados: ${semana.diasTrabajados}`);
      console.log(`  • Total tareos: ${semana.totalTareos}`);
      console.log(`  • ¿Tiene info descuento?: ${semana.infoDescanso ? 'SÍ' : 'NO'}`);
      if (semana.infoDescanso) {
        const descuentoCalculado = (8 / 7) * semana.infoDescanso.faltas;
        console.log(`    → Descanso final: ${semana.infoDescanso.descansoProporcionado.toFixed(2)}h de 8h base`);
        console.log(`    → Faltas: ${semana.infoDescanso.faltas} (descuento: ${descuentoCalculado.toFixed(2)}h)`);
        console.log(`    → Días laborables: ${semana.infoDescanso.diasLaborables} (incluye toda la semana)`);
        console.log(`    → Días trabajados efectivos: ${semana.infoDescanso.diasTrabajadosEfectivos}`);
      }
      console.log('');
    });
    
    const semanasConDescuento = semanas.filter(s => s.infoDescanso);
    console.log(`🎯 RESULTADO: ${semanasConDescuento.length}/${semanas.length} semanas tienen información de descuento`);
    console.log('📊 === FIN CÁLCULO RESÚMENES SEMANALES ===');
    
    return semanas;
  };

  // 📅 FUNCIÓN PARA RENDERIZAR TAREOS CON RESÚMENES SEMANALES
  const renderizarTareosConResumen = () => {
    const semanas = calcularResumenSemanal();
    const filas = [];
    
    semanas.forEach((semana, semanaIndex) => {
      // Agregar todas las filas de tareos de la semana
      semana.tareos.forEach((registro, registroIndex) => {
        const key = `tareo-${semanaIndex}-${registroIndex}`;
        
        filas.push(
          <tr key={key} className={`hover:bg-gray-50 ${getEstadoColor(registro.estado)} ${
            esFechaFueraDePeriodo(registro.fecha) 
              ? 'opacity-50 bg-gray-100 text-gray-500' 
              : ''
          }`}>
            <td className="px-3 py-2 text-sm">
              <div>
                <div className={`font-medium ${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : 'text-gray-900'
                }`}>
                  {registro.fechaFormateada}
                </div>
                <div className={`text-xs ${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : 'text-gray-500'
                }`}>
                  {registro.diaSemana}
                </div>
              </div>
            </td>
            <td className="px-3 py-2 text-sm">
              <div className="flex items-center">
                <span className={`mr-2 ${
                  esFechaFueraDePeriodo(registro.fecha) ? 'opacity-50' : ''
                }`}>{getTipoIcon(registro.tipo)}</span>
                <span className={`font-medium ${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : ''
                }`}>{registro.tipo}</span>
              </div>
            </td>
            <td className="px-3 py-2 text-sm">
              <div>
                {registro.conceptos && registro.conceptos.length > 0 ? (
                  <div className="space-y-1">
                    {registro.conceptos.map((concepto, idx) => {
                      // 🏛️ BUSCAR CONCEPTO PLAME REAL POR ID
                      console.log(`🔍 === CONCEPTO ===`, concepto);
                      const conceptoPlameReal = buscarConceptoPlamePorId(concepto.plame_configuracion_id);
                      
                      // Usar concepto PLAME real si existe, sino usar datos del concepto
                      const nombreConcepto = conceptoPlameReal?.descripcion || 
                                            concepto.plame_configuracion?.descripcion || 
                                            concepto.nombre || 
                                            concepto.descripcion || 
                                            concepto.plame_configuracion?.nombre ||
                                            'Sin nombre de concepto';
                      
                      const montoConcepto = concepto.monto || concepto.valor || 0;
                      
                      const codigoPlame = conceptoPlameReal?.codigo_plame ||
                                         concepto.plame_configuracion?.codigo_plame || 
                                         concepto.codigoPlame || 
                                         concepto.codigo_plame || 
                                         null;
                      
                      console.log(`💰 Concepto ${idx + 1}:`, {
                        plame_configuracion_id: concepto.plame_configuracion_id,
                        conceptoPlameReal,
                        nombreConcepto,
                        codigoPlame,
                        montoConcepto
                      });
                      
                      return (
                        <div key={idx} className="text-xs">
                    <div className={`font-medium ${
                      esFechaFueraDePeriodo(registro.fecha) 
                        ? 'text-gray-400' 
                        : 'text-gray-900'
                    }`}>
                            {nombreConcepto}
                    </div>
                          <div className={`font-semibold ${
                            esFechaFueraDePeriodo(registro.fecha) 
                              ? 'text-gray-400' 
                              : 'text-teal-600'
                          }`}>
                            {formatCurrency(montoConcepto)}
                    </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className={`font-medium ${
                    esFechaFueraDePeriodo(registro.fecha) 
                      ? 'text-gray-400' 
                      : 'text-gray-500'
                  }`}>
                    -
                  </div>
                )}
              </div>
            </td>
            <td className="px-3 py-2 text-sm text-center">
              <div>
                <div className={`font-semibold ${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : 'text-gray-900'
                }`}>
                  {formatHorasMinutos(registro.horasOrdinarias)}
                </div>
                
                {/* ✅ MOSTRAR DIFERENCIA CON HORAS TEÓRICAS REALES */}
                {(() => {
                  // Solo calcular diferencia para días de asistencia efectiva
                  const esAsistencia = registro.tipo === 'Asistió' || registro.tipo === 'asistencia';
                  const horasTeoricasCalculadas = registro.horasTeoricasDecimales || 8;

                  // Asistió pero con 0 horas registradas → mostrar minutos a restar (teóricas completas como descuento)
                  if (esAsistencia && registro.horasOrdinarias === 0 && horasTeoricasCalculadas > 0) {
                    const minutosARestar = Math.round(horasTeoricasCalculadas * 60);
                    return (
                      <div className={`text-xs font-medium ${
                        esFechaFueraDePeriodo(registro.fecha) 
                          ? 'text-gray-400' 
                          : 'text-red-600'
                      }`}>
                        -{minutosARestar} min
                      </div>
                    );
                  }

                  if (esAsistencia && registro.horasOrdinarias > 0) {
                    const diferencia = registro.horasOrdinarias - horasTeoricasCalculadas;
                    const minutosDiferencia = Math.abs(diferencia * 60);
                    
                    console.log(`🕐 Comparación horas - Teóricas: ${horasTeoricasCalculadas}h, Reales: ${registro.horasOrdinarias}h, Diferencia: ${diferencia}h`);
                    
                    if (diferencia > 0.05) { // Tolerancia de 3 minutos (0.05h)
                      return (
                        <div className={`text-xs font-medium ${
                          esFechaFueraDePeriodo(registro.fecha) 
                            ? 'text-gray-400' 
                            : 'text-green-600'
                        }`}>
                          +{Math.round(minutosDiferencia)} min
                        </div>
                      );
                    } else if (diferencia < -0.05) {
                      return (
                        <div className={`text-xs font-medium ${
                          esFechaFueraDePeriodo(registro.fecha) 
                            ? 'text-gray-400' 
                            : 'text-red-600'
                        }`}>
                          -{Math.round(minutosDiferencia)} min
                        </div>
                      );
                    } else {
                      return (
                        <div className={`text-xs font-medium ${
                          esFechaFueraDePeriodo(registro.fecha) 
                            ? 'text-gray-400' 
                            : 'text-gray-500'
                        }`}>
                          ✓ Completo
                        </div>
                      );
                    }
                  }
                  return null;
                })()}
                
                {(registro.horasExtra25 > 0 || registro.horasExtra35 > 0) && (
                  <div className="text-xs space-y-1 mt-1">
                    {registro.horasExtra25 > 0 && (
                      <div className={`${
                        esFechaFueraDePeriodo(registro.fecha) 
                          ? 'text-gray-400' 
                          : 'text-orange-600'
                      }`}>+{formatHorasMinutos(registro.horasExtra25)} (25%)</div>
                    )}
                    {registro.horasExtra35 > 0 && (
                      <div className={`${
                        esFechaFueraDePeriodo(registro.fecha) 
                          ? 'text-gray-400' 
                          : 'text-red-600'
                      }`}>+{formatHorasMinutos(registro.horasExtra35)} (35%)</div>
                    )}
                  </div>
                )}
              </div>
            </td>
            {tasaNocturnaActiva && (
              <td className="px-3 py-2 text-sm text-center">
                {registro.considerarTasaNocturna ? (
                  <span
                    className={`inline-flex items-center px-1.5 py-0.5 rounded font-medium text-xs ${
                      esFechaFueraDePeriodo(registro.fecha)
                        ? 'bg-gray-100 text-gray-400'
                        : 'bg-indigo-100 text-indigo-800'
                    }`}
                    title="Este día considera tasa nocturna"
                  >
                    🌙 Sí
                  </span>
                ) : (
                  <span className={esFechaFueraDePeriodo(registro.fecha) ? 'text-gray-400' : 'text-gray-400'}>
                    No
                  </span>
                )}
              </td>
            )}
            <td className="px-3 py-2 text-sm text-center">
              <div className="text-xs">
                <div className={`${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : 'text-gray-600'
                }`}>
                  T: {registro.horaEntradaTeorica || '08:00:00'}-{registro.horaSalidaTeorica || '17:00:00'}
                </div>
                <div className={`${
                  esFechaFueraDePeriodo(registro.fecha) 
                    ? 'text-gray-400' 
                    : 'text-gray-500'
                }`}>
                  R: {registro.horaEntrada !== '---' ? `${registro.horaEntrada}:00-${registro.horaSalida}:00` : '---'}
                </div>
              </div>
            </td>
            <td className={`px-3 py-2 text-sm ${
              esFechaFueraDePeriodo(registro.fecha) 
                ? 'text-gray-400' 
                : 'text-gray-600'
            }`}>
              {registro.observaciones || '-'}
            </td>
          </tr>
        );
      });
      
      // Agregar fila de resumen semanal después del último día de la semana
      if (semana.esDomingo || semanaIndex === semanas.length - 1) {
        const keyResumen = `resumen-semana-${semanaIndex}`;
        
        // 🔍 DEBUG: Log de información de descuento para cada semana
        console.log(`🗓️ === RENDERIZANDO SEMANA ${semana.fechaInicio} - ${semana.fechaFin} ===`);
        console.log(`📊 Datos de la semana:`, {
          horasTotal: semana.horasTotal,
          diasTrabajados: semana.diasTrabajados,
          totalTareos: semana.totalTareos,
          infoDescanso: semana.infoDescanso,
          tieneInfoDescanso: !!semana.infoDescanso
        });
        
        if (semana.infoDescanso) {
          console.log(`💤 INFO DESCUENTO ENCONTRADA:`, semana.infoDescanso);
        } else {
          console.warn(`⚠️ NO HAY INFO DE DESCUENTO PARA ESTA SEMANA`);
        }
        
        filas.push(
          <tr key={keyResumen} className="bg-blue-50 border-t-2 border-blue-200 font-medium">
            <td colSpan={columnasTablaTareos} className="px-3 py-3 text-sm">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center">
                    <span className="text-lg mr-2">📊</span>
                    <span className="font-bold text-blue-800">
                      Resumen Semana {semana.fechaInicio} - {semana.fechaFin}
                    </span>
                  </div>
                                       <div className="flex items-center space-x-6 text-sm">
                     <div className="flex items-center">
                       <span className="text-blue-600 mr-1">⏰</span>
                       <span className="font-semibold text-blue-800">
                         Total: {formatHorasMinutos(semana.horasTotal)}
                       </span>
                     </div>
                                           {semana.horasEnPlomo > 0 && (
                        <div className="flex items-center">
                          <span className="text-gray-500 mr-1">⚪</span>
                          <span className="text-gray-600">
                            Período: {formatHorasMinutos(semana.horasPeriodo)}
                          </span>
                        </div>
                      )}
                     <div className="flex items-center">
                       <span className="text-green-600 mr-1">✅</span>
                       <span className="text-green-700">
                         {semana.diasTrabajados} días trabajados
                       </span>
                     </div>
                     <div className="flex items-center">
                       <span className="text-purple-600 mr-1">📅</span>
                       <span className="text-purple-700">
                         {semana.totalTareos} registros
                       </span>
                     </div>
                     {semana.infoDescanso && (
                       <div className="flex items-center">
                         <span className="text-indigo-600 mr-1">💤</span>
                         <span className="text-indigo-700">
                           Descanso: {formatHorasMinutos(semana.infoDescanso.descansoProporcionado)} de 8h
                           {semana.infoDescanso.faltas > 0 && (
                             <span className="text-red-600 ml-1">
                               ({semana.infoDescanso.faltas} falta{semana.infoDescanso.faltas > 1 ? 's' : ''})
                             </span>
                           )}
                         </span>
                       </div>
                     )}
                   </div>
                </div>
              </div>
            </td>
          </tr>
        );
      }
    });
    
    return filas;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-7xl w-full max-h-[85vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-teal-50 px-6 py-4 border-b border-teal-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-bold text-gray-900">
                Tareos - {empleado?.nombre}
              </h2>
              <p className="text-sm text-gray-600">
                {empleado?.cargo} • {empleado?.documento}
              </p>
              {empleado?.regimenLaboral && (
                <div className="mt-1 flex items-center space-x-3 text-xs">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full font-medium">
                    {empleado.regimenLaboral}
                  </span>
                  {empleado?.tipoAporte && (
                    <span className={`px-2 py-1 rounded-full font-medium ${
                      empleado.tipoAporte === 'ONP' ? 'bg-green-100 text-green-700' : 'bg-purple-100 text-purple-700'
                    }`}>
                      {empleado.tipoAporte}
                    </span>
                  )}
                  {empleado?.totales?.netoAPagar && (
                    <span className="text-gray-600">
                      💰 Neto: <span className="font-semibold text-teal-700">{formatCurrency(empleado.totales.netoAPagar)}</span>
                    </span>
                  )}
                </div>
              )}
            </div>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-white rounded-lg transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500 mx-auto"></div>
                <p className="mt-2 text-gray-600">Cargando información...</p>
              </div>
            </div>
          ) : tareoData ? (
            <div className="space-y-8">
              {/* SECCIÓN 1: CONCEPTOS DE LA PLANILLA */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                <div className="bg-gradient-to-r from-teal-50 to-blue-50 px-6 py-4 rounded-t-xl border-b border-teal-200">
                  <h2 className="text-xl font-bold text-gray-900 flex items-center">
                    <span className="mr-3 text-2xl">💰</span>
                    Conceptos de la Planilla
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Todos los conceptos que conforman la planilla de {empleado?.nombre}
                  </p>
                </div>
                
                <div className="p-6">
                  <div className="grid md:grid-cols-3 gap-6">
                  {/* Ingresos */}
                  <div className="bg-white rounded-lg p-4 border border-green-200">
                    <h4 className="font-medium text-green-800 mb-3 flex items-center">
                      <span className="mr-2">📈</span>
                      Ingresos
                    </h4>
                    <div className="space-y-2">
                      {empleado?.conceptos?.ingresos?.map((concepto, index) => {
                        const esAfectoTareos = concepto.descripcion.includes('Sueldo') || 
                                             concepto.descripcion.includes('Horas') ||
                                             concepto.descripcion.includes('Ordinaria');
                        
                        // Usar la base de cálculo que viene del service de planilla
                        const baseCalculo = concepto.base_calculo || concepto.baseCalculo;
                        
                        // 🔍 LOG EN TIEMPO REAL PARA INGRESOS
                        console.log(`💰 INGRESO - ${concepto.descripcion}:`);
                        console.log(`  • base_calculo: ${concepto.base_calculo}`);
                        console.log(`  • baseCalculo: ${concepto.baseCalculo}`);
                        console.log(`  • baseCalculo final: ${baseCalculo}`);
                        console.log(`  • ¿Se mostrará base?: ${!!baseCalculo}`);
                        
                        return (
                          <div key={index} className="flex justify-between items-center text-sm">
                            <div className="flex-1">
                              <span className="text-green-700 font-medium">{concepto.descripcion}</span>
                              <div className="text-xs text-gray-600 space-y-1">
                                <div className="flex items-center">
                                  {baseCalculo && (
                                    <span className="text-blue-600">Base: {formatCurrency(baseCalculo)}</span>
                                  )}
                                  {concepto.codigoPlame && (
                                    <span className={`${baseCalculo ? 'ml-2 ' : ''}text-purple-600 font-mono`}>
                                      PLAME: {concepto.codigoPlame}
                                    </span>
                                  )}
                                </div>
                                {esAfectoTareos && (
                                  <span className="px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full text-xs font-medium flex items-center inline-flex">
                                    <span className="mr-1">⏰</span>
                                    Afecto a Tareos
                                  </span>
                                )}
                              </div>
                            </div>
                            <span className="font-semibold text-green-800 ml-2">
                              {formatCurrency(concepto.monto)}
                            </span>
                          </div>
                        );
                      }) || []}
                      {(!empleado?.conceptos?.ingresos || empleado.conceptos.ingresos.length === 0) && (
                        <p className="text-sm text-gray-500 italic">No hay ingresos</p>
                      )}
                    </div>
                    <div className="mt-3 pt-3 border-t border-green-200">
                      <div className="flex justify-between items-center font-semibold">
                        <span className="text-green-800">Total Ingresos:</span>
                        <span className="text-green-900">
                          {formatCurrency(empleado?.totales?.totalIngresos || 0)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Descuentos */}
                  <div className="bg-white rounded-lg p-4 border border-red-200">
                    <h4 className="font-medium text-red-800 mb-3 flex items-center">
                      <span className="mr-2">📉</span>
                      Descuentos
                    </h4>
                    <div className="space-y-2">
                      {empleado?.conceptos?.descuentos?.map((concepto, index) => {
                        // Usar la base de cálculo que viene del service de planilla
                        const baseCalculo = concepto.base_calculo || concepto.baseCalculo;
                        
                        // 🔍 LOG EN TIEMPO REAL PARA DESCUENTOS
                        console.log(`📉 DESCUENTO - ${concepto.descripcion}:`);
                        console.log(`  • base_calculo: ${concepto.base_calculo}`);
                        console.log(`  • baseCalculo: ${concepto.baseCalculo}`);
                        console.log(`  • baseCalculo final: ${baseCalculo}`);
                        console.log(`  • ¿Se mostrará base?: ${!!baseCalculo}`);
                        
                        return (
                        <div key={index} className="flex justify-between items-center text-sm">
                          <div className="flex-1">
                            <span className="text-red-700 font-medium">{concepto.descripcion}</span>
                              <div className="text-xs text-gray-600 space-y-1">
                                <div className="flex items-center">
                                  {baseCalculo && (
                                    <span className="text-blue-600">Base: {formatCurrency(baseCalculo)}</span>
                                  )}
                                  {concepto.codigoPlame && (
                                    <span className={`${baseCalculo ? 'ml-2 ' : ''}text-purple-600 font-mono`}>
                              PLAME: {concepto.codigoPlame}
                                    </span>
                                  )}
                                </div>
                            </div>
                          </div>
                          <span className="font-semibold text-red-800 ml-2">
                            {formatCurrency(concepto.monto)}
                          </span>
                        </div>
                        );
                      }) || []}
                      {(!empleado?.conceptos?.descuentos || empleado.conceptos.descuentos.length === 0) && (
                        <p className="text-sm text-gray-500 italic">No hay descuentos</p>
                      )}
                    </div>
                    <div className="mt-3 pt-3 border-t border-red-200">
                      <div className="flex justify-between items-center font-semibold">
                        <span className="text-red-800">Total Descuentos:</span>
                        <span className="text-red-900">
                          {formatCurrency(empleado?.totales?.totalDescuentos || 0)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Aportes */}
                  <div className="bg-white rounded-lg p-4 border border-blue-200">
                    <h4 className="font-medium text-blue-800 mb-3 flex items-center">
                      <span className="mr-2">🏛️</span>
                      Aportes del Empleador
                    </h4>
                    <div className="space-y-2">
                      {empleado?.conceptos?.aportes?.map((concepto, index) => {
                        // Usar la base de cálculo que viene del service de planilla
                        const baseCalculo = concepto.base_calculo || concepto.baseCalculo;
                        
                        // 🔍 LOG EN TIEMPO REAL PARA APORTES
                        console.log(`🏛️ APORTE - ${concepto.descripcion}:`);
                        console.log(`  • base_calculo: ${concepto.base_calculo}`);
                        console.log(`  • baseCalculo: ${concepto.baseCalculo}`);
                        console.log(`  • baseCalculo final: ${baseCalculo}`);
                        console.log(`  • ¿Se mostrará base?: ${!!baseCalculo}`);
                        
                        return (
                        <div key={index} className="flex justify-between items-center text-sm">
                          <div className="flex-1">
                            <span className="text-blue-700 font-medium">{concepto.descripcion}</span>
                              <div className="text-xs text-gray-600 space-y-1">
                                <div className="flex items-center">
                                  {baseCalculo && (
                                    <span className="text-blue-600">Base: {formatCurrency(baseCalculo)}</span>
                                  )}
                                  {concepto.codigoPlame && (
                                    <span className={`${baseCalculo ? 'ml-2 ' : ''}text-purple-600 font-mono`}>
                              PLAME: {concepto.codigoPlame}
                                    </span>
                                  )}
                                </div>
                            </div>
                          </div>
                          <span className="font-semibold text-blue-800 ml-2">
                            {formatCurrency(concepto.monto)}
                          </span>
                        </div>
                        );
                      }) || []}
                      {(!empleado?.conceptos?.aportes || empleado.conceptos.aportes.length === 0) && (
                        <p className="text-sm text-gray-500 italic">No hay aportes</p>
                      )}
                    </div>
                    <div className="mt-3 pt-3 border-t border-blue-200">
                      <div className="flex justify-between items-center font-semibold">
                        <span className="text-blue-800">Total Aportes:</span>
                        <span className="text-blue-900">
                          {formatCurrency(empleado?.totales?.totalAportes || 0)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Resumen Final */}
                <div className="mt-6 pt-4 border-t border-teal-200">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total Ingresos</p>
                      <p className="text-lg font-bold text-green-600">
                        {formatCurrency(empleado?.totales?.totalIngresos || 0)}
                      </p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total Descuentos</p>
                      <p className="text-lg font-bold text-red-600">
                        {formatCurrency(empleado?.totales?.totalDescuentos || 0)}
                      </p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total Aportes</p>
                      <p className="text-lg font-bold text-blue-600">
                        {formatCurrency(empleado?.totales?.totalAportes || 0)}
                      </p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Neto a Pagar</p>
                      <p className="text-xl font-bold text-teal-600">
                        {formatCurrency(empleado?.totales?.netoAPagar || 0)}
                      </p>
                    </div>
                  </div>
                </div>
                </div>
              </div>

              {/* SECCIÓN 2: COMPENSACIONES DE MESES PASADOS */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                                  <div className="bg-gradient-to-r from-amber-50 to-yellow-50 px-4 py-3 rounded-t-xl border-b border-amber-200">
                  <h2 className="text-lg font-bold text-gray-900 flex items-center">
                    <span className="mr-3 text-xl">💤</span>
                    Compensaciones
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Cálculo de compensaciones para el próximo mes
                  </p>
                </div>
                
                <div className="p-4">
                  {loadingCompensaciones ? (
                    <div className="flex items-center justify-center py-8">
                      <div className="text-center">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-amber-500 mx-auto"></div>
                        <p className="mt-2 text-sm text-gray-600">Cargando compensaciones...</p>
                      </div>
                    </div>
                  ) : compensacionesEmpleado ? (
                                         <div className="space-y-4">
                       {/* Información del empleado */}
                       <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
                         <h4 className="font-medium text-blue-800 mb-3 flex items-center">
                           <span className="mr-2">👤</span>
                           Compensación del Empleado
                         </h4>
                        
                                                 {compensacionesEmpleado?.compensacion ? (
                           <div className="space-y-4">
                             {(() => {
                               // 📊 CALCULAR HORAS DEL MES ACTUAL
                               const horasMesesAnteriores = parseFloat(compensacionesEmpleado?.compensacion?.horas_compensadas) || 0;
                               
                               // Filtrar tareos del período actual (no en plomo)
                               const tareosPeriodoActual = tareosDiarios.filter(registro => 
                                 !esFechaFueraDePeriodo(registro.fecha)
                               );
                               
                               // Calcular compensación: Teóricas - Reales = Diferencia
                               let minutosExtrasMes = 0;
                               let diasProcesados = 0;
                               let diasLaborables = 0;
                               
                               tareosPeriodoActual.forEach(tareo => {
                                 console.log(`📅 PRINCIPAL - REVISANDO DÍA ${tareo.fechaFormateada}:`);
                                 console.log(`  • Tipo: ${tareo.tipo}`);
                                 console.log(`  • Día semana: ${tareo.diaSemana}`);
                                 console.log(`  • Horas ordinarias: ${tareo.horasOrdinarias}h`);
                                 
                                 // ✅ PROCESAR TODOS LOS DÍAS (NO FILTRAR SÁBADOS Y DOMINGOS)
                                 diasLaborables++;
                                 console.log(`  ✅ Procesando día`);
                                 
                                 // Solo procesar días donde realmente trabajó (no faltas, vacaciones, etc.)
                                 const esAsistenciaEfectiva = tareo.tipo === 'Asistió' || 
                                                             tareo.tipo === 'Feriado Laborado' || 
                                                             tareo.tipo === 'Descanso Laborado';
                                 
                                 console.log(`  • ¿Asistencia efectiva?: ${esAsistenciaEfectiva ? 'SÍ' : 'NO'}`);
                                 console.log(`  • ¿Tiene horas > 0?: ${tareo.horasOrdinarias > 0 ? 'SÍ' : 'NO'}`);
                                 
                                 // Asistió (o Feriado/Descanso laborado): incluir siempre; si horas = 0 se restan las teóricas
                                 if (esAsistenciaEfectiva) {
                                   diasProcesados++;
                                   
                                   const horasTeoricasCalculadas = tareo.horasTeoricasDecimales || 8;
                                   const horasRealesTrabajadas = tareo.horasOrdinarias;
                                   
                                   // Diferencia: Reales - Teóricas (si 0h registradas → diferencia negativa = minutos a restar)
                                   const diferenciaDia = horasRealesTrabajadas - horasTeoricasCalculadas;
                                   const minutosDiferencia = Math.round(diferenciaDia * 60);
                                   minutosExtrasMes += minutosDiferencia;
                                   
                                   console.log(`  ✅ PROCESADO:`);
                                   console.log(`    • Teóricas: ${horasTeoricasCalculadas}h`);
                                   console.log(`    • Reales: ${horasRealesTrabajadas}h`);
                                   console.log(`    • Diferencia: ${horasRealesTrabajadas}h - ${horasTeoricasCalculadas}h = ${diferenciaDia >= 0 ? '+' : ''}${diferenciaDia.toFixed(2)}h`);
                                   console.log(`    • Minutos: ${minutosDiferencia >= 0 ? '+' : ''}${minutosDiferencia} min`);
                                   console.log(`    • Acumulado: ${minutosExtrasMes >= 0 ? '+' : ''}${minutosExtrasMes} min`);
                                 } else {
                                   console.log(`  ❌ NO PROCESADO: no asistencia efectiva`);
                                 }
                                 console.log(''); // Línea en blanco para separar días
                               });
                               
                               // Convertir minutos totales de vuelta a horas decimales
                               const horasGeneradasMes = minutosExtrasMes / 60;
                               
                               // Total para el próximo mes
                               const totalProximoMes = horasMesesAnteriores + horasGeneradasMes;
                               
                               // Datos para mostrar en la UI
                               const horasEsperadas = diasLaborables * 8;
                               const horasReales = tareosPeriodoActual.reduce((sum, t) => sum + t.horasOrdinarias, 0);
                               
                               console.log('💤 CÁLCULO DE COMPENSACIONES CORREGIDO:');
                               console.log(`  • Horas meses anteriores: ${horasMesesAnteriores}h`);
                               console.log(`  • Días laborables totales: ${diasLaborables}`);
                               console.log(`  • Días con asistencia efectiva: ${diasProcesados}`);
                               console.log(`  • Total minutos extras acumulados: ${minutosExtrasMes} min`);
                               console.log(`  • Horas generadas este mes: ${horasGeneradasMes.toFixed(2)}h`);
                               console.log(`  • Total próximo mes: ${totalProximoMes.toFixed(2)}h`);
                               console.log(`  • [INFO] Horas esperadas totales: ${horasEsperadas}h`);
                               console.log(`  • [INFO] Horas reales totales: ${horasReales}h`);
                               
                               return (
                                 <div className="bg-white rounded-lg border border-blue-200 p-3">
                                   <div className="flex items-center justify-between">
                                     <div className="flex items-center space-x-4 text-sm">
                                       <span className="text-gray-600">🧮 Compensación:</span>
                                       
                                       {/* Meses anteriores */}
                                       <div className="flex items-center">
                                         {horasMesesAnteriores >= 0 ? (
                                           <span className="text-green-600">+{formatHorasMinutos(Math.abs(horasMesesAnteriores))}</span>
                                         ) : (
                                           <span className="text-red-600">-{formatHorasMinutos(Math.abs(horasMesesAnteriores))}</span>
                                         )}
                                         <span className="text-gray-400 mx-1">+</span>
                                       </div>
                                       
                                       {/* Este mes */}
                                       <div className="flex items-center">
                                         {horasGeneradasMes >= 0 ? (
                                           <span className="text-green-600">+{formatHorasMinutos(Math.abs(horasGeneradasMes))}</span>
                                         ) : (
                                           <span className="text-red-600">-{formatHorasMinutos(Math.abs(horasGeneradasMes))}</span>
                                         )}
                                         <span className="text-gray-400 mx-1">=</span>
                                       </div>
                                       
                                       {/* Total */}
                                       <div className="flex items-center">
                                         {(() => {
                                           const esCero = Math.abs(totalProximoMes) < 0.01;
                                           if (esCero) {
                                             return (
                                               <>
                                                 <span className="font-bold text-gray-600">0h 0min</span>
                                                 <span className="text-xs text-gray-500 ml-1 px-1 py-0.5 bg-gray-100 rounded">NO DEBE NADA</span>
                                               </>
                                             );
                                           }
                                           if (totalProximoMes > 0) {
                                             return (
                                               <>
                                                 <span className="font-bold text-green-700">+{formatHorasMinutos(Math.abs(totalProximoMes))}</span>
                                                 <span className="text-xs text-green-600 ml-1 px-1 py-0.5 bg-green-100 rounded">A FAVOR</span>
                                               </>
                                             );
                                           }
                                           return (
                                             <>
                                               <span className="font-bold text-red-700">-{formatHorasMinutos(Math.abs(totalProximoMes))}</span>
                                               <span className="text-xs text-red-600 ml-1 px-1 py-0.5 bg-red-100 rounded">EN CONTRA</span>
                                             </>
                                           );
                                         })()}
                                       </div>
                                     </div>
                                     
                                     {/* Info compacta */}
                                     <div className="text-xs text-gray-500">
                                       {diasProcesados}/{diasLaborables}d • {minutosExtrasMes >= 0 ? '+' : ''}{minutosExtrasMes}min
                                     </div>
                                   </div>
                                 </div>
                               );
                             })()}
                                                       </div>
                                                 ) : (
                           <div className="space-y-4">
                             {(() => {
                               // 📊 CALCULAR HORAS DEL MES ACTUAL CUANDO NO HAY COMPENSACIONES PREVIAS
                               const horasMesesAnteriores = 0; // Sin compensaciones previas
                               
                               // Filtrar tareos del período actual (no en plomo)
                               const tareosPeriodoActual = tareosDiarios.filter(registro => 
                                 !esFechaFueraDePeriodo(registro.fecha)
                               );
                               
                               // Calcular compensación: Teóricas - Reales = Diferencia
                               let minutosExtrasMes = 0;
                               let diasProcesados = 0;
                               let diasLaborables = 0;
                               
                               tareosPeriodoActual.forEach(tareo => {
                                 console.log(`📅 PRINCIPAL - REVISANDO DÍA ${tareo.fechaFormateada}:`);
                                 console.log(`  • Tipo: ${tareo.tipo}`);
                                 console.log(`  • Día semana: ${tareo.diaSemana}`);
                                 console.log(`  • Horas ordinarias: ${tareo.horasOrdinarias}h`);
                                 
                                 // ✅ PROCESAR TODOS LOS DÍAS (NO FILTRAR SÁBADOS Y DOMINGOS)
                                 diasLaborables++;
                                 console.log(`  ✅ Procesando día`);
                                 
                                 // Solo procesar días donde realmente trabajó (no faltas, vacaciones, etc.)
                                 const esAsistenciaEfectiva = tareo.tipo === 'Asistió' || 
                                                             tareo.tipo === 'Feriado Laborado' || 
                                                             tareo.tipo === 'Descanso Laborado';
                                 
                                console.log(`  • ¿Asistencia efectiva?: ${esAsistenciaEfectiva ? 'SÍ' : 'NO'}`);
                                console.log(`  • ¿Tiene horas > 0?: ${tareo.horasOrdinarias > 0 ? 'SÍ' : 'NO'}`);
                                
                                if (esAsistenciaEfectiva) {
                                  diasProcesados++;
                                  const horasTeoricasCalculadas = tareo.horasTeoricasDecimales || 8;
                                  const horasRealesTrabajadas = tareo.horasOrdinarias;
                                  const diferenciaDia = horasRealesTrabajadas - horasTeoricasCalculadas;
                                  const minutosDiferencia = Math.round(diferenciaDia * 60);
                                  minutosExtrasMes += minutosDiferencia;
                                  console.log(`  ✅ PROCESADO: Teóricas ${horasTeoricasCalculadas}h, Reales ${horasRealesTrabajadas}h, Diferencia ${diferenciaDia >= 0 ? '+' : ''}${diferenciaDia.toFixed(2)}h → ${minutosDiferencia >= 0 ? '+' : ''}${minutosDiferencia} min`);
                                } else {
                                  console.log(`  ❌ NO PROCESADO: no asistencia efectiva`);
                                }
                                console.log('');
                              });
                              
                              const horasGeneradasMes = minutosExtrasMes / 60;
                              
                              // Total para el próximo mes (igual a las horas generadas este mes)
                               const totalProximoMes = horasGeneradasMes;
                               
                               // Datos para mostrar en la UI
                               const horasEsperadas = diasLaborables * 8;
                               const horasReales = tareosPeriodoActual.reduce((sum, t) => sum + t.horasOrdinarias, 0);
                               
                               console.log('💤 CÁLCULO DE COMPENSACIONES SIN PREVIAS:');
                               console.log(`  • Horas meses anteriores: ${horasMesesAnteriores}h`);
                               console.log(`  • Días laborables totales: ${diasLaborables}`);
                               console.log(`  • Días con asistencia efectiva: ${diasProcesados}`);
                               console.log(`  • Total minutos extras acumulados: ${minutosExtrasMes} min`);
                               console.log(`  • Horas generadas este mes: ${horasGeneradasMes.toFixed(2)}h`);
                               console.log(`  • Total próximo mes: ${totalProximoMes.toFixed(2)}h`);
                               
                               if (diasLaborables > 0) {
                                 return (
                                   <div className="bg-white rounded-lg border border-gray-200 p-3">
                                     <div className="flex items-center justify-between">
                                       <div className="flex items-center space-x-4 text-sm">
                                         <span className="text-gray-600">🧮 Compensación:</span>
                                         
                                         {/* Meses anteriores (sin compensaciones) */}
                                         <div className="flex items-center">
                                           <span className="text-gray-500">0h 0min</span>
                                           <span className="text-gray-400 mx-1">+</span>
                                         </div>
                                         
                                         {/* Este mes */}
                                         <div className="flex items-center">
                                           {horasGeneradasMes >= 0 ? (
                                             <span className="text-green-600">+{formatHorasMinutos(Math.abs(horasGeneradasMes))}</span>
                                           ) : (
                                             <span className="text-red-600">-{formatHorasMinutos(Math.abs(horasGeneradasMes))}</span>
                                           )}
                                           <span className="text-gray-400 mx-1">=</span>
                                         </div>
                                         
                                         {/* Total */}
                                         <div className="flex items-center">
                                           {(() => {
                                             const esCero = Math.abs(totalProximoMes) < 0.01;
                                             if (esCero) {
                                               return (
                                                 <>
                                                   <span className="font-bold text-gray-600">0h 0min</span>
                                                   <span className="text-xs text-gray-500 ml-1 px-1 py-0.5 bg-gray-100 rounded">NO DEBE NADA</span>
                                                 </>
                                               );
                                             }
                                             if (totalProximoMes > 0) {
                                               return (
                                                 <>
                                                   <span className="font-bold text-green-700">+{formatHorasMinutos(Math.abs(totalProximoMes))}</span>
                                                   <span className="text-xs text-green-600 ml-1 px-1 py-0.5 bg-green-100 rounded">A FAVOR</span>
                                                 </>
                                               );
                                             }
                                             return (
                                               <>
                                                 <span className="font-bold text-red-700">-{formatHorasMinutos(Math.abs(totalProximoMes))}</span>
                                                 <span className="text-xs text-red-600 ml-1 px-1 py-0.5 bg-red-100 rounded">EN CONTRA</span>
                                               </>
                                             );
                                           })()}
                                         </div>
                                       </div>
                                       
                                       {/* Info compacta */}
                                       <div className="text-xs text-gray-500">
                                         {diasProcesados}/{diasLaborables}d • {minutosExtrasMes >= 0 ? '+' : ''}{minutosExtrasMes}min
                                       </div>
                                     </div>
                                   </div>
                                 );
                               } else {
                                 return (
                                   <div className="text-center py-6">
                                     <div className="text-gray-400 text-3xl mb-2">💤</div>
                                     <p className="text-sm text-gray-600 font-medium">Sin datos de tareos</p>
                                     <p className="text-xs text-gray-500">No hay registros suficientes para calcular compensaciones</p>
                                   </div>
                                 );
                               }
                             })()}
                           </div>
                         )}
                      </div>



                      {/* Información explicativa */}
                      {(() => {
                        const horasMesesAnteriores = parseFloat(compensacionesEmpleado?.compensacion?.horas_compensadas) || 0;
                        const tareosPeriodoActual = tareosDiarios.filter(registro => !esFechaFueraDePeriodo(registro.fecha));
                        
                        console.log('💤 === CÁLCULO EXPLICATIVO DE COMPENSACIONES ===');
                        console.log(`📊 Horas meses anteriores: ${horasMesesAnteriores}h`);
                        console.log(`📅 Tareos del período: ${tareosPeriodoActual.length}`);
                        
                        // Calcular compensación: Teóricas - Reales = Diferencia (MISMA LÓGICA QUE EL CÁLCULO PRINCIPAL)
                        let minutosExtrasMes = 0;
                        let diasLaborables = 0;
                        let diasProcesados = 0;
                        
                        tareosPeriodoActual.forEach(tareo => {
                          console.log(`📅 PRINCIPAL - REVISANDO DÍA ${tareo.fechaFormateada}:`);
                          console.log(`  • Tipo: ${tareo.tipo}`);
                          console.log(`  • Día semana: ${tareo.diaSemana}`);
                          console.log(`  • Horas ordinarias: ${tareo.horasOrdinarias}h`);
                          
                          // ✅ PROCESAR TODOS LOS DÍAS (NO FILTRAR SÁBADOS Y DOMINGOS)
                          diasLaborables++;
                          console.log(`  ✅ Procesando día`);
                          
                          // Solo procesar días donde realmente trabajó (no faltas, vacaciones, etc.)
                          const esAsistenciaEfectiva = tareo.tipo === 'Asistió' || 
                                                      tareo.tipo === 'Feriado Laborado' || 
                                                      tareo.tipo === 'Descanso Laborado';
                          
                          console.log(`  • ¿Asistencia efectiva?: ${esAsistenciaEfectiva ? 'SÍ' : 'NO'}`);
                          console.log(`  • ¿Tiene horas > 0?: ${tareo.horasOrdinarias > 0 ? 'SÍ' : 'NO'}`);
                          
                          if (esAsistenciaEfectiva) {
                            diasProcesados++;
                            const horasTeoricasCalculadas = tareo.horasTeoricasDecimales || 8;
                            const horasRealesTrabajadas = tareo.horasOrdinarias;
                            const diferenciaDia = horasRealesTrabajadas - horasTeoricasCalculadas;
                            const minutosDiferencia = Math.round(diferenciaDia * 60);
                            minutosExtrasMes += minutosDiferencia;
                            console.log(`  ✅ PROCESADO: Teóricas ${horasTeoricasCalculadas}h, Reales ${horasRealesTrabajadas}h → ${minutosDiferencia >= 0 ? '+' : ''}${minutosDiferencia} min`);
                          } else {
                            console.log(`  ❌ NO PROCESADO: no asistencia efectiva`);
                          }
                          console.log('');
                        });
                        
                        const horasGeneradasMes = minutosExtrasMes / 60;
                        const totalProximoMes = horasMesesAnteriores + horasGeneradasMes;
                        
                        console.log('💤 === RESUMEN EXPLICATIVO ===');
                        console.log(`📊 Días laborables totales: ${diasLaborables}`);
                        console.log(`📊 Días procesados: ${diasProcesados}`);
                        console.log(`📊 Total minutos extras: ${minutosExtrasMes} min`);
                        console.log(`📊 Horas generadas mes: ${horasGeneradasMes.toFixed(2)}h`);
                        console.log(`📊 Total próximo mes: ${totalProximoMes.toFixed(2)}h`);
                        console.log(`📊 ¿Mostrar mensaje?: ${Math.abs(totalProximoMes) > 0.01 ? 'SÍ' : 'NO'}`);
                        console.log('💤 === FIN CÁLCULO EXPLICATIVO ===');
                        
                        if (Math.abs(totalProximoMes) > 0.01) { // Solo mostrar si hay diferencia significativa
                          return (
                            <div className="bg-blue-50 rounded-lg p-3 border-l-4 border-blue-400">
                              <div className="flex items-start">
                                <div className="text-blue-400 text-lg mr-3">ℹ️</div>
                                <div>
                                  <h5 className="font-medium text-blue-800 mb-1">Para el próximo mes</h5>
                                  <p className="text-sm text-blue-700">
                                    {Math.abs(totalProximoMes) < 0.01
                                      ? "No debe nada. Sin horas pendientes para el próximo mes."
                                      : totalProximoMes > 0
                                        ? `Se trasladarán ${formatHorasMinutos(Math.abs(totalProximoMes))} A FAVOR al próximo mes.`
                                        : `Se trasladarán ${formatHorasMinutos(Math.abs(totalProximoMes))} EN CONTRA al próximo mes.`
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  ) : (
                    <div className="text-center py-8">
                      <div className="text-gray-400 text-4xl mb-4">⚠️</div>
                      <p className="text-gray-600 font-medium">No se pudieron cargar las compensaciones</p>
                      <p className="text-sm text-gray-500">Verifique la configuración del sistema</p>
                    </div>
                  )}
                </div>
              </div>

              {/* SECCIÓN 3: RESUMEN DE TAREOS */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 rounded-t-xl border-b border-purple-200">
                  <h2 className="text-xl font-bold text-gray-900 flex items-center">
                    <span className="mr-3 text-2xl">📊</span>
                    Resumen de Tareos
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Estadísticas y resumen del período de tareos
                  </p>
                </div>
                
                <div className="px-4 py-3">
                  {/* Resumen por tipo de tareo */}
                  <div className="mb-4">
                    <h5 className="text-sm font-semibold text-gray-700 mb-3">Resumen por Tipo de Registro</h5>
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                      {(() => {
                        // 📅 FILTRAR SOLO TAREOS DEL PERÍODO DE LA PLANILLA (NO EN PLOMO)
                        const tareosFiltradosPeriodo = tareosDiarios.filter(registro => 
                          !esFechaFueraDePeriodo(registro.fecha)
                        );
                        
                        console.log(`📊 RESUMEN MODAL - Tareos totales: ${tareosDiarios.length}, Tareos del período: ${tareosFiltradosPeriodo.length}`);
                        
                        const tiposConteo = {};
                        const tiposConfig = {
                          'Asistió': { label: 'Asistió', color: 'text-green-600', bg: 'bg-green-50', icon: '✅' },
                          'Falta': { label: 'Faltas', color: 'text-red-600', bg: 'bg-red-50', icon: '❌' },
                          'Feriado': { label: 'Feriados', color: 'text-purple-600', bg: 'bg-purple-50', icon: '🎉' },
                          'Feriado Laborado': { label: 'Feriados Laborados', color: 'text-orange-600', bg: 'bg-orange-50', icon: '💼' },
                          'Descanso': { label: 'Descansos', color: 'text-blue-600', bg: 'bg-blue-50', icon: '😴' },
                          'Descanso Laborado': { label: 'Descansos Laborados', color: 'text-indigo-600', bg: 'bg-indigo-50', icon: '⚡' },
                          'Descanso Médico': { label: 'Descanso Médico', color: 'text-pink-600', bg: 'bg-pink-50', icon: '🏥' },
        'Reposo Médico': { label: 'Reposo Médico', color: 'text-rose-600', bg: 'bg-rose-50', icon: '🛏️' },
        'Subsidio por Enfermedad': { label: 'Subsidio por Enfermedad', color: 'text-red-500', bg: 'bg-red-50', icon: '💊' },
                          'Licencia con Goce de Haber': { label: 'Licencia con Goce de Haber', color: 'text-indigo-600', bg: 'bg-indigo-50', icon: '🧾' },
                          'Permiso': { label: 'Permisos', color: 'text-cyan-600', bg: 'bg-cyan-50', icon: '📋' },
                          'Suspensión': { label: 'Suspensiones', color: 'text-amber-600', bg: 'bg-amber-50', icon: '⛔' },
                          'Vacaciones': { label: 'Vacaciones', color: 'text-yellow-600', bg: 'bg-yellow-50', icon: '🏖️' }
                        };

                        // Contar tipos de registros (SOLO DEL PERÍODO)
                        tareosFiltradosPeriodo.forEach(registro => {
                          tiposConteo[registro.tipo] = (tiposConteo[registro.tipo] || 0) + 1;
                        });

                        // Mostrar solo los tipos que aparecen
                        return Object.entries(tiposConteo).map(([tipo, cantidad]) => {
                          const config = tiposConfig[tipo] || { 
                            label: tipo, 
                            color: 'text-gray-600', 
                            bg: 'bg-gray-50', 
                            icon: '📅' 
                          };
                          
                          return (
                            <div key={tipo} className={`${config.bg} rounded-lg p-3 text-center border`}>
                              <div className="text-lg mb-1">{config.icon}</div>
                              <p className={`text-lg font-bold ${config.color}`}>{cantidad}</p>
                              <p className="text-xs text-gray-600">{config.label}</p>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </div>

                  {/* Resumen general */}
                  <div className={`grid grid-cols-2 md:grid-cols-3 ${tasaNocturnaActiva ? 'lg:grid-cols-6' : 'lg:grid-cols-5'} gap-4 text-center`}>
                    {(() => {
                      // 📅 USAR SOLO TAREOS DEL PERÍODO (NO EN PLOMO) PARA ESTADÍSTICAS
                      const tareosFiltradosEstadisticas = tareosDiarios.filter(registro => 
                        !esFechaFueraDePeriodo(registro.fecha)
                      );
                      
                      return (
                        <>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Total Registros</p>
                            <p className="text-lg font-bold text-blue-600">{tareosFiltradosEstadisticas.length}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Días Trabajados</p>
                      <p className="text-lg font-bold text-green-600">
                              {tareosFiltradosEstadisticas.filter(t => 
                          t.tipo === 'Asistió' || 
                          t.tipo === 'Feriado Laborado' || 
                          t.tipo === 'Descanso Laborado' ||
                          t.tipo === 'Descanso Médico' ||
                          t.tipo === 'Subsidio por Enfermedad' ||
                          t.tipo === 'Licencia con Goce de Haber'
                        ).length}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Horas Totales</p>
                      <p className="text-lg font-bold text-teal-600">
                              {formatHorasMinutos(tareosFiltradosEstadisticas.reduce((sum, t) => sum + t.horasOrdinarias, 0))}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Horas Extra 25%</p>
                      <p className="text-lg font-bold text-orange-600">
                        {(() => {
                                const horasTareos = tareosFiltradosEstadisticas.reduce((sum, t) => sum + (t.horasExtra25 || 0), 0);
                          const horasAutorizaciones = procesarHorasExtrasAutorizaciones().horasExtra25;
                          const totalHoras = horasTareos + horasAutorizaciones;
                          return formatHorasMinutos(totalHoras);
                        })()}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">Horas Extra 35%</p>
                      <p className="text-lg font-bold text-purple-600">
                        {(() => {
                                const horasTareos = tareosFiltradosEstadisticas.reduce((sum, t) => sum + (t.horasExtra35 || 0), 0);
                          const horasAutorizaciones = procesarHorasExtrasAutorizaciones().horasExtra35;
                          const totalHoras = horasTareos + horasAutorizaciones;
                          return formatHorasMinutos(totalHoras);
                        })()}
                      </p>
                    </div>
                    {tasaNocturnaActiva && (
                      <div>
                        <p className="text-sm font-medium text-gray-600">Días T. Noct.</p>
                        <p className="text-lg font-bold text-indigo-600">
                          {tareosFiltradosEstadisticas.filter((t) => t.considerarTasaNocturna).length}
                        </p>
                      </div>
                    )}
                        </>
                      );
                    })()}
                  </div>
                  
                  {/* Botón para mostrar estadísticas (solo si hay suficientes tareos) */}
                  {tieneTareosParaEstadisticas() && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <div className="flex items-center justify-between mb-3">
                        <h6 className="text-sm font-semibold text-gray-700 flex items-center">
                          <span className="mr-2">📊</span>
                          Estadísticas Avanzadas del Período
                          <span className="ml-2 text-xs text-gray-500">(Con fórmulas de cálculo)</span>
                        </h6>
                        <button
                          onClick={() => setMostrarEstadisticas(!mostrarEstadisticas)}
                          className="flex items-center px-3 py-2 text-sm font-medium text-teal-600 bg-teal-50 hover:bg-teal-100 rounded-lg transition-colors"
                        >
                          <span className="mr-2">
                            {mostrarEstadisticas ? '📊' : '👁️'}
                          </span>
                          {mostrarEstadisticas ? 'Ocultar Estadísticas' : 'Ver Estadísticas'}
                          <svg 
                            className={`ml-2 w-4 h-4 transition-transform ${mostrarEstadisticas ? 'rotate-180' : ''}`} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                  
                  {/* Estadísticas Avanzadas del Período (solo si hay suficientes tareos y está visible) */}
                  {tieneTareosParaEstadisticas() && mostrarEstadisticas && (
                    <div className="mt-4">
                    
                    {(() => {
                      // 📅 USAR SOLO TAREOS DEL PERÍODO (NO EN PLOMO) PARA ESTADÍSTICAS AVANZADAS
                      const tareosFiltradosAvanzadas = tareosDiarios.filter(registro => 
                        !esFechaFueraDePeriodo(registro.fecha)
                      );
                      
                      // Calcular estadísticas detalladas
                      const totalRegistros = tareosFiltradosAvanzadas.length;
                      const diasAsistidos = tareosFiltradosAvanzadas.filter(t => 
                        t.tipo === 'Asistió' || 
                        t.tipo === 'Feriado Laborado' || 
                        t.tipo === 'Descanso Laborado'
                      ).length;
                      const horasTotales = tareosFiltradosAvanzadas.reduce((sum, t) => sum + t.horasOrdinarias, 0);
                      const faltas = tareosFiltradosAvanzadas.filter(t => t.tipo === 'Falta').length;
                      const tardanzas = tareosFiltradosAvanzadas.filter(t => t.horasOrdinarias > 0 && t.horasOrdinarias < 8 && t.tipo === 'Asistió').length;
                      const vacaciones = tareosFiltradosAvanzadas.filter(t => t.tipo === 'Vacaciones').length;
                      const permisos = tareosFiltradosAvanzadas.filter(t => t.tipo === 'Permiso').length;
                      
                      // Cálculos de indicadores
                      const promedioDiario = diasAsistidos > 0 ? (horasTotales / diasAsistidos) : 0;
                      const porcentajeAsistencia = totalRegistros > 0 ? ((diasAsistidos / totalRegistros) * 100) : 0;
                      const porcentajeAusentismo = totalRegistros > 0 ? (((faltas + vacaciones + permisos) / totalRegistros) * 100) : 0;
                      const eficienciaHoras = diasAsistidos > 0 ? ((horasTotales / (diasAsistidos * 8)) * 100) : 0;
                      const indicePuntualidad = totalRegistros > 0 ? (((totalRegistros - tardanzas) / totalRegistros) * 100) : 0;
                      
                      return (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {/* Promedio Diario */}
                          <div className="bg-green-50 rounded-lg p-3 border border-green-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Promedio Diario</p>
                              <p className="text-xl font-bold text-green-600">
                                {formatHorasMinutos(promedioDiario)}
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                Horas Totales ÷ Días Asistidos<br/>
                                {formatHorasMinutos(horasTotales)} ÷ {diasAsistidos} = {formatHorasMinutos(promedioDiario)}
                              </p>
                            </div>
                          </div>

                          {/* Porcentaje de Asistencia */}
                          <div className="bg-teal-50 rounded-lg p-3 border border-teal-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Asistencia</p>
                              <p className="text-xl font-bold text-teal-600">
                                {porcentajeAsistencia.toFixed(0)}%
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                (Días Asistidos ÷ Total Registros) × 100<br/>
                                ({diasAsistidos} ÷ {totalRegistros}) × 100 = {porcentajeAsistencia.toFixed(0)}%
                              </p>
                            </div>
                          </div>

                          {/* Ausentismo */}
                          <div className="bg-red-50 rounded-lg p-3 border border-red-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Ausentismo</p>
                              <p className="text-xl font-bold text-red-600">
                                {porcentajeAusentismo.toFixed(1)}%
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                (Faltas + Vacaciones + Permisos) ÷ Total × 100<br/>
                                ({faltas} + {vacaciones} + {permisos}) ÷ {totalRegistros} × 100 = {porcentajeAusentismo.toFixed(1)}%
                              </p>
                            </div>
                          </div>

                          {/* Eficiencia de Horas */}
                          <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Eficiencia Horas</p>
                              <p className="text-xl font-bold text-blue-600">
                                {eficienciaHoras.toFixed(1)}%
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                (Horas Reales ÷ Horas Esperadas) × 100<br/>
                                {formatHorasMinutos(horasTotales)} ÷ ({diasAsistidos} × 8h) × 100 = {eficienciaHoras.toFixed(1)}%
                              </p>
                            </div>
                          </div>

                          {/* Índice de Puntualidad */}
                          <div className="bg-purple-50 rounded-lg p-3 border border-purple-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Puntualidad</p>
                              <p className="text-xl font-bold text-purple-600">
                                {indicePuntualidad.toFixed(0)}%
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                (Días Sin Tardanza ÷ Total Registros) × 100<br/>
                                ({totalRegistros - tardanzas} ÷ {totalRegistros}) × 100 = {indicePuntualidad.toFixed(0)}%
                              </p>
                            </div>
                          </div>

                          {/* Productividad General */}
                          <div className="bg-yellow-50 rounded-lg p-3 border border-yellow-200">
                            <div className="text-center mb-2">
                              <p className="text-xs text-gray-600">Productividad</p>
                              <p className="text-xl font-bold text-yellow-600">
                                {((porcentajeAsistencia + indicePuntualidad + eficienciaHoras) / 3).toFixed(0)}%
                              </p>
                            </div>
                            <div className="text-xs text-gray-500 bg-white rounded p-2">
                              <p className="font-mono">
                                📐 <strong>Fórmula:</strong><br/>
                                (Asistencia + Puntualidad + Eficiencia) ÷ 3<br/>
                                ({porcentajeAsistencia.toFixed(0)} + {indicePuntualidad.toFixed(0)} + {eficienciaHoras.toFixed(0)}) ÷ 3 = {((porcentajeAsistencia + indicePuntualidad + eficienciaHoras) / 3).toFixed(0)}%
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })()}


                    </div>
                  )}
                </div>
              </div>

              {/* SECCIÓN 4: TAREOS DEL EMPLEADO */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                <div className="bg-gradient-to-r from-green-50 to-blue-50 px-6 py-4 rounded-t-xl border-b border-green-200">
                  <h2 className="text-xl font-bold text-gray-900 flex items-center">
                    <span className="mr-3 text-2xl">📅</span>
                    Tareos del Empleado
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Registro diario de asistencia y horas trabajadas del período de planilla
                  </p>
                </div>

                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Fecha
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Tipo
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Conceptos
                        </th>
                        <th className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Horas
                        </th>
                        {tasaNocturnaActiva && (
                          <th className="px-3 py-2 text-center text-xs font-medium text-indigo-700 uppercase tracking-wider">
                            T. Noct.
                          </th>
                        )}
                        <th className="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Horarios
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Observaciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {tareosDiarios.length === 0 ? (
                        <tr>
                          <td colSpan={columnasTablaTareos} className="px-6 py-12 text-center">
                            <div className="text-gray-500">
                              <div className="text-4xl mb-4">📅</div>
                              <h3 className="text-lg font-medium text-gray-900 mb-2">No hay tareos registrados</h3>
                              <p className="text-sm text-gray-600 mb-4">
                                No se encontraron registros de tareos para este empleado en el período de la planilla.
                              </p>
                              <p className="text-xs text-gray-500">
                                Datos del empleado: {empleado?.id} | Array keys: {empleado ? Object.keys(empleado).join(', ') : 'undefined'}
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        renderizarTareosConResumen()
                      )}
                    </tbody>
                  </table>
                </div>


              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500">No se encontraron datos de tareo</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex-shrink-0">
          <div className="flex justify-between items-center">
            {/* Botón de descarga de boleta */}
            <div className="flex space-x-3">
              {empleado && generarBoletaIndividual && (
                <button
                  onClick={() => generarBoletaIndividual(empleado)}
                  disabled={generandoBoletaIndividual}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${
                    generandoBoletaIndividual
                      ? 'bg-gray-400 text-white cursor-not-allowed'
                      : 'bg-blue-600 text-white hover:bg-blue-700'
                  }`}
                >
                  {generandoBoletaIndividual ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Generando...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Descargar Boleta</span>
                    </>
                  )}
                </button>
              )}
            </div>

            {/* Botones de acción */}
            <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cerrar
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TareoModal; 